import React, { Component, useEffect, useRef, useState } from 'react';
import { BrowserRouter as Router, Route, Link, Redirect, NavLink, HashRouter } from "react-router-dom";
import Header from './../../Header';
import HeaderMob from './../../HeaderMob';
import Profile_img from './../../assets/images/user-male.png';
//import SelectField from 'material-ui/SelectField';
//import MenuItem from 'material-ui/MenuItem';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import $ from 'jquery';
import 'react-datepicker/dist/react-datepicker.css'
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
import AutoComplete from 'material-ui/AutoComplete';
import CAutocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import { withStyles } from "@material-ui/core/styles";
import Followers from './follower';
import * as actionFunction from "../../actions/common";
import EmployeeActivityInsightsTable from "./EmployeeActivityInsightsTable";
import { TextField } from '@material-ui/core';

const ext_arr = ["jpeg", "jpg", "jpe", "JPEG", "png"];
const dataSourceConfig = {
	text: 'title',
	value: 'id',
};
const selected_permission = [];
const selected_group = [];
const selected_group_id = [];
const selected_group_listener = [];
const selected_pod = [];
const selected_corp = [];
const selected_primary = [];
const selected_listener = [];
const selected_department = [];
const CustomAutocomplete = withStyles({
	root: {
		fontFamily: "Poppins-Regular",
		padding: "0px 0px",
		"& .MuiInputLabel-outlined:not(.MuiInputLabel-shrink)": {
			// Default transform is "translate(14px, 20px) scale(1)""
			// This lines up the label with the initial cursor position in the input
			// after changing its padding-left.
			transform: "translate(34px, 20px) scale(1);"
		}
	},
	inputRoot: {
		color: "#555",
		border: "1",
		borderColor: "#DBE1EA",
		fontFamily: "Poppins-Regular",
		fontSize: "12px",
		// This matches the specificity of the default styles at https://github.com/mui-org/material-ui/blob/v4.11.3/packages/material-ui-lab/src/Autocomplete/Autocomplete.js#L90
		'&[class*="MuiOutlinedInput-root"] .MuiAutocomplete-input:first-child': {
			// Default left padding is 6px
			paddingLeft: 0
		},
		"& .MuiOutlinedInput-notchedOutline": {
			borderColor: "#DBE1EA"
		},
		"&:hover .MuiOutlinedInput-notchedOutline": {
			borderColor: "#DBE1EA"

		},
		"&.Mui-focused .MuiOutlinedInput-notchedOutline": {
			borderColor: "#DBE1EA",
			border: "1px solid",
		}
	},
	listbox: {
		fontFamily: "Poppins-Regular",
		fontSize: "12px",
	},
	popupIndicator: {
		display: "none",
	},
	tag: {
		backgroundColor: "#F1FCFF",
		borderColor: '#D9F6FD',
		border: "1px solid",
		fontFamily: "Poppins-Regular",
		fontSize: "12px",
		lineHeight: "18px",
		height: 24,
		borderRadius: "4px",
		position: "relative",
		zIndex: 0,
		"& .MuiChip-label": {
			color: "#86979C"
		},
		"& .MuiChip-deleteIcon": {
			color: "#d1d1d1bf"
		},
		"&:after": {
			content: '""',
			right: 10,
			top: 6,
			height: 12,
			width: 12,
			position: "absolute",
			backgroundColor: "white",
			zIndex: -1
		}
	}
})(CAutocomplete);
class ViewEmployee extends Component {
	constructor(props) {
		super(props);
		var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
		var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
		this.state = {
			pod: [],
			team: [],
			employee: '',
			manager_user: [],
			hiring_profile: [],
			selected_pods: [],
			EmailGroup: [],
			name: '',
			groups: [],
			apiUrl: this.decryptconfigdata('apiUrl'),
			userAuthKey: has_local_data ? localdata.user_key : '',
			userId: has_local_data ? localdata.user_id : '',
			userEmail: has_local_data ? localdata.user_email : '',
			userName: has_local_data ? localdata.user_name : '',
			date_of_joining: moment(),
			date_of_birth: moment(),
			fields: {},
			errors: {},
			roles: {},
			manager: '',
			emp_start_name: '',
			permission_name: '',
			group_name: '',
			view_access: '',
			edit_access: '',
			emr_save_state: 1,
			con_save_state: 1,
			per_save_state: 1,
			job_save_state: 1,
			registered_mail: '',
			loading: 1,
			hr_permission: '',
			manager_permission: '',
			source: [],
			department: '',
			func_manager: '',
			manager_resp: '',
			date_of_previousexp: '',
			viewEmpId: props.match.params.user_uuid ? '' : props.match.params.employeeId,
			selected_group_id: [],
			selected_group_listener: [],
			department_names: [],
			troop_names: [],
			pod_names: [],
			crop_names: [],
			email_names: [],
			selected_pod: [],
			selected_corp: [],
			troop_names: [],
			employeee: [],
			group: [],
			groupDepartment: [],
			groupPod: [],
			groupCorp: [],
			selected_permission: [],
			myscore: [],
			peer_question: [],
			comments: [],
			//                        bolApiUrl:'http://recruitment.ranjita.com',
			followerData: [],
			actualfollowerData: [],
			followType: [],
			followerDataCount: "",
			flowoneval: "",
			flowtwoval: "",
			all_user_list: [],
			imageLoader: 0,
			errors: {},
			defaultItemToShow: 5,
			//ER:116571
			countries: [],
			states: [],
			cities: [],
			selectedCountry: '',
			selectedState: '',
			selectedCity: '',
			selectedEmrCountry: '',
			selectedEmrState: '',
			selectedEmrCity: '',
			emrcities: [],
			emrcountries: [],
			emrstates: [],
		};
		this.viewEmployee = this.viewEmployee.bind(this);
		//		this.onProjectChange = this.onProjectChange.bind(this);
		this.onChange = this.onChange.bind(this);
		//		this.handleChangeDateOfJoining = this.handleChangeDateOfJoining.bind(this);
		this.handleChangeDateOfBirth = this.handleChangeDateOfBirth.bind(this);
		this.handleChangePreviousexp = this.handleChangePreviousexp.bind(this);
		//		this.podChange = this.podChange.bind(this);
		this.onEmailGroupChange = this.onEmailGroupChange.bind(this);
		//		this.onEmailGroupChange_list = this.onEmailGroupChange_list.bind(this);
		this.handleGroupChange = this.handleGroupChange.bind(this);
		this.handleListenerGroupChange = this.handleListenerGroupChange.bind(this);
		this.handlePermissionChange = this.handlePermissionChange.bind(this);
		//                this.setRelationshipStatus = this.setRelationshipStatus.bind(this);
		//                this.findBolEmployee = this.findBolEmployee.bind(this);
		//                this.resetSearchBox = this.resetSearchBox.bind(this);
		this.uploadProfileImage = this.uploadProfileImage.bind(this);
	}
	decryptconfigdata(configkey) {
		var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
		var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
		var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
			iv
		});
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		return plaintext;
	}

	decrypt(findresponse, flg) {
		var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
		var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
		var res = flg ? findresponse.encdata : findresponse;
		var bytes = CryptoJS.AES.decrypt(res, key, {
			iv
		});
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		return JSON.parse(plaintext);
	}
	onEmailGroupChange = (event, index, EmailGroup) => {
		let fields = this.state.fields;
		this.setState({
			EmailGroup: EmailGroup
		});
	}
	/*onEmailGroupChange_list = (event, index, EmailGroup_list) => {
		let fields = this.state.fields;
		this.setState({
			EmailGroup_list: EmailGroup_list
		});
	}*/
	/*podChange = (event, index, selected_pods) => {
		let fields = this.state.fields;
		this.setState({ selected_pods: selected_pods });
		console.log(selected_pods);
	}*/
	isValidEmailAddress(emailAddress) {
		var pattern = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
		return pattern.test(emailAddress);
	}


	handlePermissionChange = (event, index) => {
		var value = event.target.value;
		if (event.target.value != '') {
			var strArray = value.split("/");

			var object = { 'id': strArray[0], 'name': strArray[1] };
			this.state.selected_permission.push(object);

			const fd = new FormData;
			fd.append('permission', JSON.stringify(this.state.selected_permission));

			fetch(this.state.apiUrl + '/employee/updatepermission/userAuthKey/' + this.state.userAuthKey + '/id/' + this.state.viewEmpId + '/userId/' + this.state.userId, {
				method: 'POST',
				dataType: 'json',
				body: fd,
			})
				.then((Response) => Response.json())
				.then((responseJson) => {
					responseJson = this.decrypt(responseJson, 1);
					if (responseJson.code == 200) {
						this.viewEmployee();
						this.setState({ selected_permission: this.state.selected_permission })

					}
					else {
						this.setState({ registered_mail: responseJson.msg })
					}
				})



		}
	}

	addPrimaryGroups = async (groups) => {
		console.log("Listener groups", groups);

		if (groups && groups.length <= 0) {
			return { code: 400, message: 'No groups to add' };
		}

		try {
			let fd = new FormData();
			const data = groups.map(group => {
				return {
					'id': group.id,
					'name': group.name,
					'email': group.email,
					'group_type': group.group_type,
					'is_primary': 1
				}
			})
			fd.append('group', JSON.stringify(data));

			const response = await fetch(this.state.apiUrl + '/employee/updateGroupData/userAuthKey/' + this.state.userAuthKey + '/id/' + this.state.viewEmpId + '/userId/' + this.state.userId, {
				method: 'POST',
				dataType: 'json',
				body: fd,
			});
			let responseJson = await response.json();
			responseJson = this.decrypt(responseJson, 1);
			console.log("responseJson Add Listener Group", responseJson);
			if (responseJson.code == 200) {
				this.viewEmployee();
				return { code: 200, message: 'Groups added successfully' };
			} else {
				return { code: 400, message: responseJson.msg || 'Something went wrong' };
			}
		} catch (error) {
			return { code: 400, message: 'Something went wrong' };
		}
	}

	addListenerGroups = async (groups) => {
		console.log("Listener groups", groups);

		if (groups && groups.length <= 0) {
			return { code: 400, message: 'No groups to add' };
		}

		try {
			let fd = new FormData();
			const data = groups.map(group => {
				return {
					'id': group.id,
					'name': group.name,
					'email': group.email,
					'group_type': group.group_type,
					'is_primary': 0
				}
			})
			fd.append('group', JSON.stringify(data));

			const response = await fetch(this.state.apiUrl + '/employee/updateGroupData/userAuthKey/' + this.state.userAuthKey + '/id/' + this.state.viewEmpId + '/userId/' + this.state.userId, {
				method: 'POST',
				dataType: 'json',
				body: fd,
			});
			let responseJson = await response.json();
			responseJson = this.decrypt(responseJson, 1);
			console.log("responseJson Add Listener Group", responseJson);
			if (responseJson.code == 200) {
				this.viewEmployee();
				return { code: 200, message: 'Groups added successfully' };
			} else {
				return { code: 400, message: responseJson.msg || 'Something went wrong' };
			}
		} catch (error) {
			return { code: 400, message: 'Something went wrong' };
		}
	}

	addPermissions = async (permission) => {
		console.log("Permission", permission);
		if (permission && permission.length <= 0) {
			return { code: 400, message: 'No permission to add' };
		}

		try {
			const new_permissions = [...this.state.permissions, ...permission];
			console.log("new_permissions", new_permissions);
			const fd = new FormData;
			fd.append('permission', JSON.stringify(new_permissions));

			const response = await fetch(this.state.apiUrl + '/employee/updatepermission/userAuthKey/' + this.state.userAuthKey + '/id/' + this.state.viewEmpId + '/userId/' + this.state.userId, {
				method: 'POST',
				dataType: 'json',
				body: fd,
			})
			let responseJson = await response.json();
			responseJson = this.decrypt(responseJson, 1);
			if (responseJson.code == 200) {
				this.viewEmployee();
				return { code: 200, message: 'Permissions added successfully' };
			} else {
				return { code: 400, message: responseJson.msg || 'Something went wrong' };
			}
		} catch (error) {
			return { code: 400, message: 'Something went wrong' };
		}
	}

	ClosePermission = async (a) => {
		try {
			const fd = new FormData;
			fd.append('permission_id', a.id);

			const response = await fetch(this.state.apiUrl + '/employee/deletepermission/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.viewEmpId, {
				method: 'POST',
				dataType: 'json',
				body: fd,
			});
			let responseJson = await response.json();

			responseJson = this.decrypt(responseJson, 1);
			if (responseJson.code == 200) {
				this.viewEmployee();
				return { code: 200, message: 'Permission removed successfully' };
			} else {
				return { code: 400, message: responseJson.msg || 'Something went wrong' };
			}
		} catch (error) {
			return { code: 400, message: 'Something went wrong' };
		}
	}

	handleGroupChange = (event, index) => {
		var value = event.target.value;
		if (event.target.value != '') {
			var strArray = value.split("/");
			let fd = new FormData();
			var object = { 'id': strArray[0], 'name': strArray[1], 'email': strArray[2], 'group_type': strArray[3], 'is_primary': 1 };
			fd.append('group', JSON.stringify(object));

			fetch(this.state.apiUrl + '/employee/updategroupdata/userAuthKey/' + this.state.userAuthKey + '/id/' + this.state.viewEmpId + '/userId/' + this.state.userId, {
				method: 'POST',
				dataType: 'json',
				body: fd,
			})
				.then((Response) => Response.json())
				.then((responseJson) => {
					responseJson = this.decrypt(responseJson, 1);
					if (responseJson.code == 400) {
						this.setState({ registered_mail: responseJson.msg })
						// document.getElementById("addsave").innerHTML = "Save";
					} else {
						this.viewEmployee();
					}
				});

			this.state.selected_group_id.push(object);
			this.state.group.push(object);
			if (object.group_type == 1) {
				this.state.groupDepartment.push(object);
				this.setState({ groupDepartment: this.state.groupDepartment })
			}
			if (object.group_type == 2) {
				this.state.groupPod.push(object);
				this.setState({ groupPod: this.state.groupPod })
			}
			if (object.group_type == 4) {
				this.state.groupCorp.push(object);
				this.setState({ groupCorp: this.state.groupCorp })
			}
			this.setState({ selected_group_id: this.state.selected_group_id })
		}
	}
	handleListenerGroupChange = (event, index) => {
		var value = event.target.value;
		if (event.target.value != '') {
			var strArray = value.split("/");


			let fd = new FormData();
			var object = { 'id': strArray[0], 'name': strArray[1], 'email': strArray[2], 'group_type': strArray[3], 'is_primary': 0 };
			// console.log(object);
			// selected_group_listener.push(object);
			fd.append('group', JSON.stringify(object));
			fetch(this.state.apiUrl + '/employee/updateGroupData/userAuthKey/' + this.state.userAuthKey + '/id/' + this.state.viewEmpId + '/userId/' + this.state.userId, {
				method: 'POST',
				dataType: 'json',
				body: fd,
			})
				.then((Response) => Response.json())
				.then((responseJson) => {
					responseJson = this.decrypt(responseJson, 1);
					if (responseJson.code == 400) {
						this.setState({ registered_mail: responseJson.msg })
						// document.getElementById("addsave").innerHTML = "Save";
					} else {
						this.viewEmployee();
					}
				})

			this.setState({
				selected_group_listener: this.state.selected_group_listener
			})
			this.state.selected_group_listener.push(object);
			this.state.group.push(object);
			if (object.group_type == 1) {
				this.state.groupDepartment.push(object);
				this.setState({
					groupDepartment: this.state.groupDepartment
				})
			}
			if (object.group_type == 2) {
				this.state.groupPod.push(object);
				this.setState({
					groupPod: this.state.groupPod
				})
			}
			if (object.group_type == 4) {
				this.state.groupCorp.push(object);
				this.setState({
					groupCorp: this.state.groupCorp
				})
			}
		}
	}
	CloseMemberFromGroup = async (employee_id, group_id, is_primary) => {
		try {
			const fd = new FormData;
			fd.append('member_id', employee_id);
			fd.append('group_id', group_id);
			fd.append('is_primary', is_primary);
			const response = await fetch(this.state.apiUrl + '/employee/deletememberfromgroup/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
				method: 'POST',
				dataType: 'json',
				body: fd,
			})
			let responseJson = await response.json();
			responseJson = this.decrypt(responseJson, 1);
			if (responseJson.code == 200) {
				this.viewEmployee();
				return { code: 200, message: 'Member removed successfully' };
			} else {
				return { code: 400, message: responseJson.msg || 'Something went wrong' };
			}
		} catch (error) {
			return { code: 400, message: 'Something went wrong' };
		}
	}

	isValidNumber(number) {
		var pattern = /^[0-9]+$/;
		return pattern.test(number);
	}

	fileSelecthandler = (event) => {
		this.setState({ selectedFile: event.target.files[0] });
	}

	handleEmployeeValidation() {
		let fields = this.state.employee;
		let errors = {};
		let formIsValid = true;
		if (!fields["name"]) {
			formIsValid = false;
			errors["emp_name_save"] = "This field is required.";
		}
		if (!fields["position"]) {
			formIsValid = false;
			errors["emp_position_save"] = "This field is required.";
		}
		if (!fields["muvi_employee_id"]) {
			formIsValid = false;
			errors["emp_id_save"] = "This field is required.";
		}

		const pattern = /^Muv \d+$/;
		if (!pattern.test(fields["muvi_employee_id"])) {
			formIsValid = false;
			errors["emp_id_save"] = "Invalid Muvi Employee ID format. It should start with 'Muv' followed by a space and digits.";
		}

		if (!fields["email"]) {
			formIsValid = false;
			errors["emp_email_save"] = "This field is required.";
		}

		if (!fields["linkedin_url"]) {
			formIsValid = false;
			errors["emp_linkedin_save"] = "This field is required.";
		}

		{/*if (!fields["team"]) {
			formIsValid = false;
			errors["emp_team_save"] = "This field is required.";
		}*/}
		if (fields["email"] && !this.isValidEmailAddress(fields["email"])) {
			formIsValid = false;
			errors["emp_email_save"] = "Please Provide Correct Email.";
		}
		{/*
		if (!fields["year"] || !fields["month"]) {
			formIsValid = false;
			errors["emp_year_save"] = "Both fields required.";
		}
		if (fields["year"] && (fields["month"] && (!this.isValidNumber(fields["month"]) || fields["month"] >= 12))) {
			formIsValid = false;
			errors["emp_year_save"] = "Invalid Month.";
		}
		if (fields["year"] && !this.isValidNumber(fields["year"])) {
			formIsValid = false;
			errors["emp_year_save"] = "Invalid Year.";
		}*/}
		if (!fields["level"]) {
			formIsValid = false;
			errors["emp_level_save"] = "This field is required.";
		}
		this.setState({ errors: errors });
		return formIsValid;
	}
	handlePersonalValidation() {
		let fields = this.state.employee;
		let errors = {};
		let formIsValid = true;
		if (fields["per_email"] && !this.isValidEmailAddress(fields["per_email"])) {
			formIsValid = false;
			errors["per_email_save"] = "Please Provide Correct Email.";
		}
		/*if (!fields["per_phoneno"]) {
		formIsValid = false;
		errors["per_phoneno_save"] = "This field is required.";
		}*/
		if (fields["per_phoneno"] && !this.isValidNumber(fields["per_phoneno"])) {
			formIsValid = false;
			errors["per_phoneno_save"] = "Please Provide Numbers Only.";
		}
		if (fields["per_phoneno"]) {
			var mob = fields["per_phoneno"];
			if ((!mob) || (mob.length < 10)) {
				formIsValid = false;
				errors["per_phoneno_save"] = "Please enter 10 digit numbers.";
			}
		}
		if (fields["per_zipcode"] && !this.isValidNumber(fields["per_zipcode"])) {
			formIsValid = false;
			errors["per_zip_save"] = "Please Provide Numbers Only.";
		}
		/*if (!this.state.date_of_birth) {
		formIsValid = false;
		errors["date_of_birth"] = "This field is required.";
		}*/

		this.setState({ errors: errors });
		return formIsValid;
	}

	handleConfidentialValidation() {
		let fields = this.state.employee;
		let errors = {};
		let formIsValid = true;

		if (!fields["adhaar"]) {
			formIsValid = false;
			errors["con_adhaar_save"] = "This field is required.";
		}
		if (fields["esop"] && !this.isValidNumber(fields["esop"])) {
			formIsValid = false;
			errors["emr_esop_save"] = "Please Provide Numbers Only.";
		}

		this.setState({ errors: errors });
		return formIsValid;
	}
	getDepartment(searchText = '') {
		fetch(this.state.apiUrl + '/employee/getdepartment/userAuthKey/' + this.state.userAuthKey + '/searchText/' + searchText, {
			method: 'GET',
			//                dataType: 'json',
			//                body: JSON.stringify(this.state),
			headers: {
				'Content-Encoding': 'gzip',
				'Content-Type': 'application/json'
			},
		}).then(response => {
			if (!response.ok) {
				throw new Error('Network response was not ok');
			}
			return response;
		}).then(response => response.arrayBuffer()) // Get response body as ArrayBuffer
			.then(buffer => {
				const findresponse = actionFunction.decompressjsondata(buffer);
				if (findresponse.code == 200) {
					this.setState({
						search: findresponse.assign_to,
						errorText: ''
					})
				} else {
					this.setState({ errorText: findresponse.msg })
				}
			}).catch(error => {
				console.error('There was a problem with the fetch operation:', error);
			});
	}
	getManager(searchText1 = '') {
		fetch(this.state.apiUrl + '/employee/getmanager/userAuthKey/' + this.state.userAuthKey + '/searchText/' + searchText1, {
			method: 'POST',
			dataType: 'json',
			body: JSON.stringify(this.state),
		})
			.then((Response) => Response.json())
			.then((findresponse) => {
				findresponse = this.decrypt(findresponse, 1);
				if (findresponse.code == 200) {
					this.setState({
						search: findresponse.assign_to,
						errorText1: '',
					})
				} else {
					this.setState({ errorText1: findresponse.msg })
				}

			})
	}
	getManager_func(searchText1 = '') {
		fetch(this.state.apiUrl + '/employee/getmanager/userAuthKey/' + this.state.userAuthKey + '/searchText/' + searchText1, {
			method: 'POST',
			dataType: 'json',
			body: JSON.stringify(this.state),
		})
			.then((Response) => Response.json())
			.then((findresponse) => {
				findresponse = this.decrypt(findresponse, 1);
				if (findresponse.code == 200) {
					this.setState({
						search: findresponse.assign_to,
						errorText2: ''
					})
				} else {
					this.setState({ errorText2: findresponse.msg })
				}

			})
	}
	handleUpdateInput = (searchText) => {
		if (typeof searchText !== "string") {
			//check autocomplete is blank or having value?if not having value make it blank
			if (this.state.employee.department) {
				//console.log(1);
				searchText = this.state.employee.department;
			} else {
				//console.log(2);
				searchText = this.state.department;
			}
		}
		this.setState({
			searchText: searchText,
		});
		//console.log(searchText);
		this.getDepartment(searchText);
	};
	onNewRequest(chosenRequest, index) {
		//console.log('onNewRequest', chosenRequest, index);
		this.setState({
			department: chosenRequest.title
		})
		this.state.employee.department = "";
		//console.log(this.state.department);
	}

	handleUpdateInput_manager = (searchText1) => {
		if (typeof searchText1 !== "string") {
			//check autocomplete is blank or having value?if not having value make it blank
			if (this.state.manager) {
				searchText1 = this.state.manager !== "None" ? this.state.manager : '';
			} else {
				searchText1 = this.state.assign_to_title;
			}
		}
		this.setState({ searchText1: searchText1 });
		this.getManager(searchText1);
	};
	handleUpdateInput_func_manager = (searchText2) => {
		if (typeof searchText2 !== "string") {
			//check autocomplete is blank or having value?if not having value make it blank
			if (this.state.functional_manager) {
				searchText2 = this.state.functional_manager !== "None" ? this.state.functional_manager : '';
			} else {
				searchText2 = this.state.assign_to_title1;
			}
		}
		this.setState({ searchText2: searchText2 });
		this.getManager_func(searchText2);
	};


	onNewRequest_manager(chosenRequest, index) {
		//console.log('onNewRequest', chosenRequest, index);
		this.setState({
			manager_resp: chosenRequest.id,
			assign_to_title: chosenRequest.title
		})
		this.state.manager = "";
		//console.log(this.state.department);
	}
	onNewRequest_func_manager(chosenRequest, index) {
		//console.log('onNewRequest', chosenRequest, index);
		this.setState({
			func_manager: chosenRequest.id,
			assign_to_title1: chosenRequest.title
		})
		this.state.functional_manager = "";
		//console.log(this.state.department);
	}

	handleEmergencyValidation() {
		let fields = this.state.employee;
		let errors = {};
		let formIsValid = true;
		if (fields["emr_phone_no"] && !this.isValidNumber(fields["emr_phone_no"])) {
			formIsValid = false;
			errors["emr_phone_save"] = "Please Provide Numbers Only.";
		}
		if (fields["emr_zipcode"] && !this.isValidNumber(fields["emr_zipcode"])) {
			formIsValid = false;
			errors["emr_zip_save"] = "Please Provide Numbers Only.";
		}

		this.setState({ errors: errors });
		return formIsValid;
	}

	/*handleChangeDateOfJoining(date) {
		this.setState({
			date_of_joining: date
		}, function () {
			//console.log(this.state);
		});
	}*/
	handleChangePreviousexp(date) {
		this.setState({
			date_of_previousexp: date
		}, function () {
			//console.log(this.state);
			//this.ticketsList();
		});
	}
	getEmployeeList() {
		fetch(this.state.apiUrl + '/employee/getallemployees/userAuthKey/' + this.state.userAuthKey, {
			//                method: 'POST',
			method: 'GET',
			headers: {
				'Content-Encoding': 'gzip',
				'Content-Type': 'application/json'
			},
		}).then(response => {
			if (!response.ok) {
				throw new Error('Network response was not ok');
			}
			return response;
		}).then(response => response.arrayBuffer()) // Get response body as ArrayBuffer
			.then(buffer => {
				const findresponse = actionFunction.decompressjsondata(buffer);

				const department_names = findresponse.department_names.map(ele => ({ ...ele, group_type_name: "Department" }));
				const pod_names = findresponse.pod_names.map(ele => ({ ...ele, group_type_name: "Pod" }));
				const crop_names = findresponse.crop_names.map(ele => ({ ...ele, group_type_name: "Crop" }));
				const email_names = findresponse.group_email.map(ele => ({ ...ele, group_type_name: "Email Group" }));
				const troop_names = findresponse.troop_names.map(ele => ({ ...ele, group_type_name: "Troop" }));

				this.setState({
					department_names: department_names,
					pod_names: pod_names,
					crop_names: crop_names,
					email_names: email_names,
					troop_names: troop_names,
					all_groups: [...department_names, ...pod_names, ...crop_names, ...email_names, ...troop_names],
				})
			}).catch(error => {
				console.error('There was a problem with the fetch operation:', error);
			});
	}

	onChange(propertyName, event) {
		if (propertyName == 'muvi_employee_id') {
			if (this.state.hr_permission != 'yes') {
				return;
			}
			console.log('onChange', propertyName, event.target.value);

			let errors = this.state.errors;
			
			const value = event.target.value;
			const pattern = /^Muv \d+$/;

			if (!pattern.test(value)) {
				errors["emp_id_save"] = "Invalid Muvi Employee ID format. It should start with 'Muv' followed by a space and digits.";
			} else {
				errors["emp_id_save"] = "";
			}
			this.setState({ errors: errors });
		}
		
		const employee = this.state.employee;
		employee[propertyName] = event.target.value;
		this.setState({ employee: employee });
	}

	handleChangeDateOfBirth(date) {
		this.setState({
			date_of_birth: date
		});
	}
	viewEmployee() {
		fetch(this.state.apiUrl + '/employee/view/id/' + this.state.viewEmpId + '/userId/' + this.state.userId + '/userAuthKey/' + this.state.userAuthKey)
			.then(response => {
				if (!response.ok) {
					throw new Error('Network response was not ok');
				}
				return response;
			}).then(response => response.arrayBuffer()) // Get response body as ArrayBuffer
			.then(async (buffer) => {
				const responseJson = actionFunction.decompressjsondata(buffer);
				if (responseJson.code == 500) {
					window.location.href = '/employees';
					return false;
				} else {
					const countries = await this.fetchCountries();
					let states = [];
					let cities = [];
					const selectedCountry = countries.find(country => country.name === responseJson.employee.per_country);
					if (selectedCountry) {
						states = await this.fetchStates(selectedCountry.iso2);
					}

					const selectedState = states.find(state => state.name === responseJson.employee.per_state);
					if (selectedState) {
						cities = await this.fetchCities(selectedCountry.iso2, selectedState.iso2);
					}
					const selectedCity = cities.find(city => city.name === responseJson.employee.per_city)

					let emrstates = [];
					let emrcities = [];
					const selectedEmrCountry = countries.find(country => country.name === responseJson.employee.emr_country);
					if (selectedEmrCountry) {
						emrstates = await this.fetchStates(selectedEmrCountry.iso2);
					}
					const selectedEmrState = emrstates.find(state => state.name === responseJson.employee.emr_state);

					if (selectedEmrState) {
						emrcities = await this.fetchCities(selectedEmrCountry.iso2, selectedEmrState.iso2);
					}
					const selectedEmrCity = emrcities.find(city => city.name === responseJson.employee.emr_city)

					this.setState({
						countries: countries,
						emrcountries: countries,
						states: states,
						emrstates: emrstates,
						cities: cities,
						emrcities: emrcities,
						selectedCountry: selectedCountry ? selectedCountry.iso2 : "",
						selectedState: selectedState ? selectedState.iso2 : "",
						selectedCity: selectedCity ? selectedCity.name : "",
						selectedEmrCountry: selectedEmrCountry ? selectedEmrCountry.iso2 : "",
						selectedEmrState: selectedEmrState ? selectedEmrState.iso2 : "",
						selectedEmrCity: selectedEmrCity ? selectedEmrCity.name : "",
						loading: 0,
						hiring_profile: responseJson.hiring_profile,
						employee: responseJson.employee,
						groups: responseJson.groups,
						manager: responseJson.manager,
						functional_manager: responseJson.functional_manager,
						emp_start_name: responseJson.emp_start_name,
						permissions: responseJson.permissions,
						selected_permission: responseJson.permissions,
						permission_name: responseJson.permission_name,
						manager_user: responseJson.manager_user,
						group_name: responseJson.group_name,
						view_access: responseJson.view_access,
						edit_access: responseJson.edit_access,
						pod: responseJson.pod,
						team: responseJson.team,
						selected_pods: responseJson.selected_pods,
						//                            email_groups: responseJson.email_groups,
						EmailGroup: responseJson.EmailGroup,
						//                            EmailGroup_list:responseJson.EmailGroup_list,
						er_config: responseJson.er_config,
						employee_role: responseJson.employee_role,
						selected_group_id: responseJson.primary,
						selected_group_listener: responseJson.listener,
						group: responseJson.group,
						groupDepartment: responseJson.groupDepartment,
						groupPod: responseJson.groupPod,
						groupCorp: responseJson.groupCrop,
						permissions_data: responseJson.permissions_data,
						//                                        followerArr:responseJson.followerArr,
						//                                        followType:responseJson.followerArr.follow_type,
						//                                        all_user_list:responseJson.followerArr.all_user_list
						hr_permission: responseJson.hr_permission,
						manager_permission: responseJson.manager_permission
					}, function () {
						this.getEsopVal();
					})

					this.setState({ imageLoader: 0 });
					/*if(this.state.followerArr){
						console.log(815,this.state.followerArr)
						this.setState({followerDataCount:this.state.followerArr.follower_list_cnt})
						console.log(817,this.state.followerDataCount)
					}*/
					if (this.state.employee.date_of_birth != '0000-00-00') {
						this.setState({ date_of_birth: new Date(this.state.employee.date_of_birth) })
					} else {
						this.setState({ date_of_birth: "" })
					}
					if (this.state.employee.date_of_joining != '0000-00-00') {
						this.setState({ date_of_joining: new Date(this.state.employee.date_of_joining) })
					}
					if (this.state.employee.date_of_previousexp != '0000-00-00') {
						this.setState({ date_of_previousexp: new Date(this.state.employee.date_of_previousexp) })
					}

					this.setState({ searchText: this.state.employee.department });
					this.setState({ searchText1: this.state.manager !== "None" ? this.state.manager : '' });
					this.setState({ searchText2: this.state.functional_manager !== "None" ? this.state.functional_manager : '' });

					if (responseJson.hr_permission == 'yes') {
						this.id(this.props.match.params.employeeId);
					}
				}

			}).catch(error => {
				console.error('There was a problem with the fetch operation:', error);
			});
	}

	getEsopVal() {
		fetch(this.state.apiUrl + '/employee/getesopval/id/' + this.state.viewEmpId)
			.then((Response) => Response.json())
			.then((findresponse) => {
				var employee = this.state.employee;
				employee.esop_val = findresponse.esop_val;
				this.setState({ employee });
			});
	}

	emp_edit() {
		this.setState({ job_save_state: 0 });
	}

	id(id) {
		fetch(this.state.apiUrl + '/MyPerformanceRest/ViewReport/id/' + id + '/userAuthKey/' + this.state.userAuthKey, {
			method: 'GET',
			dataType: 'json',
			//            body: JSON.stringify(this.state),
		})
			.then((Response) => Response.json())
			.then((findresponse) => {
				findresponse = this.decrypt(findresponse, 1);
				this.setState({
					peer_question: findresponse.peer_question,
					myscore: findresponse.myscore,
					comments: findresponse.comments
				})
			})
	}

	empSave() {
		if (this.handleEmployeeValidation()) {
			console.log("Data Has been submitted");
			//return true;
		} else {
			console.log("This Fields Are required.")
			return false;
		}
		document.getElementById("addsave").innerHTML = "Sending....";
		document.getElementById("addsave").disabled = true;
		const fd = new FormData;
		let img = document.getElementById('imgInp').files.length;
		if (img > 0) {
			for (var x = 0; x < img; x++) {
				fd.append("image[]", document.getElementById('imgInp').files[x]);
			}
		}
		fd.append('employee_inputs', JSON.stringify(this.state));
		fd.append('date_of_joining', JSON.stringify(this.state.date_of_joining));
		fetch(this.state.apiUrl + '/employee/updateemployeeinfo/userAuthKey/' + this.state.userAuthKey + '/id/' + this.state.viewEmpId, {
			method: 'POST',
			dataType: 'json',
			body: fd,
		})
			.then((Response) => Response.json())
			.then((responseJson) => {
				responseJson = this.decrypt(responseJson, 1);
				if (responseJson.code == 400) {
					const error = this.state.errors;

					if (responseJson.empid_err) {
						error["emp_id_save"] = responseJson.empid_err;
					}

					this.setState({ registered_mail: responseJson.msg, errors: error })
					document.getElementById("addsave").innerHTML = "Save";
					//alert(this.state.registered_mail);
				}
				else {
					this.setState({ job_save_state: 1 })
					this.viewEmployee();
				}
			})

	}
	showImage(s3url) {
		window.open(s3url);
	}
	delteimage(id, img, para_id) {
		if (window.confirm('Are you sure to delete?')) {
			fetch(this.state.apiUrl + '/employee/deleteconimage/id/' + id + '/image/' + img + '/para_id/' + para_id + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId)
				.then((Response) => Response.json())
				.then((findresponse) => {
					this.viewEmployee();
				})
		}
	}
	per_edit() {
		{ this.setState({ per_save_state: 0 }) }
	}

	per_save() {
		if (this.handlePersonalValidation()) {
			console.log("Data Has been submitted");
			//return true;
		} else {
			console.log("This Fields Are required.")
			return false;
		}

		fetch(this.state.apiUrl + '/employee/updatepersonalinfo/userAuthKey/' + this.state.userAuthKey + '/id/' + this.state.viewEmpId, {
			method: 'POST',
			dataType: 'json',
			body: JSON.stringify(this.state),
		})
			.then((Response) => Response.json())
			.then((responseJson) => {
				responseJson = this.decrypt(responseJson, 1);
				{ this.setState({ per_save_state: 1 }) }
				this.viewEmployee();
			})
	}

	con_edit() {
		{ this.setState({ con_save_state: 0 }) }
	}

	con_save() {
		// if(this.handleConfidentialValidation()){
		//     console.log("Data Has been submitted");
		//     //return true;
		//  }else{
		//     console.log("This Fields Are required.")
		//     return false;
		//  }
		const fd = new FormData;

		let pan_img = document.getElementById('pan_img').files.length;
		let passport_img = document.getElementById('passport_img').files.length;
		let adhar_img = document.getElementById('adhar_img').files.length;

		if (pan_img > 0) {
			for (var x = 0; x < pan_img; x++) {
				fd.append("pan_image[]", document.getElementById('pan_img').files[x]);
			}
		}
		if (passport_img > 0) {
			for (var x = 0; x < passport_img; x++) {
				fd.append("pass_image[]", document.getElementById('passport_img').files[x]);
			}
		}
		if (adhar_img > 0) {
			for (var x = 0; x < adhar_img; x++) {
				fd.append("adhar_iamgage[]", document.getElementById('adhar_img').files[x]);
			}
		}
		fd.append('employee_inputs', JSON.stringify(this.state));
		fetch(this.state.apiUrl + '/employee/updateconfidentialinfo/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId + '/id/' + this.state.viewEmpId, {
			method: 'POST',
			dataType: 'json',
			body: fd,
		})
			.then((Response) => Response.json())
			.then((responseJson) => {
				responseJson = this.decrypt(responseJson, 1);
				{ this.setState({ con_save_state: 1 }) }
				this.viewEmployee();
			})
	}

	emr_edit() {
		{ this.setState({ emr_save_state: 0 }) }
	}
	goBack() {
		window.history.back();
	}
	emr_save() {
		if (this.handleEmergencyValidation()) {
			console.log("Data Has been submitted");
			//return true;
		} else {
			console.log("This Fields Are required.")
			return false;
		}

		fetch(this.state.apiUrl + '/employee/updateemergencyinfo/userAuthKey/' + this.state.userAuthKey + '/id/' + this.state.viewEmpId, {
			method: 'POST',
			dataType: 'json',
			body: JSON.stringify(this.state),
		})
			.then((Response) => Response.json())
			.then((responseJson) => {
				responseJson = this.decrypt(responseJson, 1);
				{ this.setState({ emr_save_state: 1 }) }
				this.viewEmployee();
			})
	}
	downloadImage(id, para) {
		var win = window.open(this.state.apiUrl + '/employee/downloadimage/id/' + id + '/user_id/' + this.state.userId + '/para_id/' + para + '/userAuthKey/' + this.state.userAuthKey, '_blank');
		win.focus()
	}

	getSaveJobInfo() {
		return (
			<span class="emps_edit" id="emp_edit" style={{}}><a href="javascript:void(0);" class="btn btn-trans Medium" onClick={this.emp_edit.bind(this)}> <i class="fa fa-pencil-square-o" aria-hidden="true"></i> Edit</a></span>
		)
	}

	getEditJobInfo() {
		return (
			<span class="emps_edit" id="emp_save" ><a a href="javascript:void(0);" id="addsave" class="btn btn-trans Medium" onClick={this.empSave.bind(this)}><i class="fa fa-floppy-o" aria-hidden="true"></i> Save</a></span>
		)
	}

	getSavePersonalInfo() {
		return (
			<span class="emps_edit" id="per_save"  ><a a href="javascript:void(0);" class="btn btn-trans Medium" onClick={this.per_save.bind(this)}><i class="fa fa-floppy-o" aria-hidden="true"></i> Save</a></span>
		)
	}

	getEditPersonalInfo() {
		return (
			<span class="emps_edit" id="per_edit" style={{}}><a href="javascript:void(0);" class="btn btn-trans Medium" onClick={this.per_edit.bind(this)}> <i class="fa fa-pencil-square-o" aria-hidden="true"></i> Edit</a></span>
		)
	}

	uploadProfileImage(e) {
		this.setState({ imageLoader: 1, loading: true });
		const fd = new FormData;
		let img = document.getElementById('imgInp').files.length;
		if (img > 0) {
			for (var x = 0; x < img; x++) {
				var filename = document.getElementById('imgInp').files[x].name;
				var file_size = document.getElementById('imgInp').files[x].size;
				var extension = filename.substring(filename.lastIndexOf('.') + 1).toLowerCase();
				var img_size = Math.round(file_size / Math.pow(1024, 2));
				var errors = this.state.errors;
				if (ext_arr.includes(extension)) {
					errors['file_extension'] = "";
					this.setState({ errors: errors });
					if (img_size > 5) {
						$("#imgInp").val("");
						this.setState({ loading: false, imageLoader: 0 });
						errors['file_extension'] = "Maximum upload file size : 5MB";
						this.setState({ errors: errors });
						return false;
					} else {
						fd.append("image[]", document.getElementById('imgInp').files[x]);
					}
				} else {
					$("#imgInp").val("");
					this.setState({ loading: false, imageLoader: 0 });
					errors['file_extension'] = "Supported image formats : jpg, png";
					this.setState({ errors: errors });
					return false;
				}
			}
		}
		fd.append("userId", this.state.employee.id);
		fetch(this.state.apiUrl + '/employee/uploadprofileimage/userAuthKey/' + this.state.userAuthKey, {
			method: 'POST',
			dataType: 'json',
			body: fd,
		})
			.then((Response) => Response.json())
			.then((findresponse) => {
				findresponse = this.decrypt(findresponse, 1);
				if (findresponse.code == 200) {
					$("#imgInp").val("");
					this.viewEmployee();
				}
			});
	}
	showMorePermissions(total_record, itemsToShow, type) {
		if (itemsToShow == this.state.defaultItemToShow) {
			if (type == "perm") {
				this.state.employee.itemsToShow_perm = total_record;
				this.state.employee.perm_collapse = true;
			} else if (type == "pod") {
				this.state.employee.itemsToShow_pod = total_record;
				this.state.employee.pod_collapse = true;
			} else if (type == "corp") {
				this.state.employee.itemsToShow_corp = total_record;
				this.state.employee.pod_collapse = true;
			} else if (type == "primarygrp") {
				this.state.employee.itemsToShow_pg = total_record;
				this.state.employee.primary_collapse = true;
			} else if (type == "listenergrp") {
				this.state.employee.itemsToShow_lg = total_record;
				this.state.employee.listener_collapse = true;
			} else if (type == "dept") {
				this.state.employee.itemsToShow_dept = total_record;
				this.state.employee.department_collapse = true;
			}
			this.forceUpdate();
		} else {
			if (type == "perm") {
				this.state.employee.itemsToShow_perm = this.state.defaultItemToShow;
				this.state.employee.perm_collapse = false;
			} else if (type == "pod") {
				this.state.employee.itemsToShow_pod = this.state.defaultItemToShow;
				this.state.employee.pod_collapse = false;
			} else if (type == "corp") {
				this.state.employee.itemsToShow_corp = this.state.defaultItemToShow;
				this.state.employee.corp_collapse = false;
			} else if (type == "primarygrp") {
				this.state.employee.itemsToShow_pg = this.state.defaultItemToShow;
				this.state.employee.primary_collapse = false;
			} else if (type == "listenergrp") {
				this.state.employee.itemsToShow_lg = this.state.defaultItemToShow;
				this.state.employee.listener_collapse = false;
			} else if (type == "dept") {
				this.state.employee.itemsToShow_dept = this.state.defaultItemToShow;
				this.state.employee.department_collapse = false;
			}
			//                this.state.employee.itemsToShow = 1;
			//                this.state.employee.collapse = false;
			this.forceUpdate();
		}
	}

	viewPersonalInfo() {
		return (
			<div>
				<span class="job_title">Personal Information</span>
				{this.state.edit_access == 0 ? '' : this.getEditPersonalInfo()}
				<div class="row intra_form">
					<div class="col-md-6 col-xs-12">
						<div class="form-group row">
							<label for="staticEmail" class="col-sm-6 col-xs-5 col-form-label">Personal Email ID</label>
							<div class="col-sm-6 col-xs-7">
								<span class="per_old_fields">{this.state.employee.per_email}</span>
							</div>
						</div>
						<div class="form-group row">
							<label for="staticEmail" class="col-sm-6 col-xs-5 col-form-label">Address Line 1</label>
							<div class="col-sm-6 col-xs-7">
								<span class="per_old_fields">{this.state.employee.per_address_1}</span>
							</div>
						</div>
						<div class="form-group row">
							<label for="staticEmail" class="col-sm-6 col-xs-5 col-form-label">City</label>
							<div class="col-sm-6 col-xs-7">
								<span class="per_old_fields">{this.state.employee.per_city}</span>
							</div>
						</div>
						<div class="form-group row">
							<label for="staticEmail" class="col-sm-6 col-xs-5 col-form-label">Country</label>
							<div class="col-sm-6 col-xs-7">
								<span class="per_old_fields">{this.state.employee.per_country}</span>
							</div>
						</div>
						<div class="form-group row">
							<label for="staticEmail" class="col-sm-6 col-xs-5 col-form-label">Phone Number</label>
							<div class="col-sm-6 col-xs-7">
								<span class="per_old_fields">{this.state.employee.per_phoneno}</span>
							</div>
						</div>
						<div class="form-group row">
							<label for="staticEmail" class="col-sm-6 col-xs-5 col-form-label">Date Of Birth</label>
							<div class="col-sm-6 col-xs-7">
								<span class="per_old_fields">{this.state.employee.date_of_birth != '0000-00-00' ? this.state.employee.dateofbirth : ''}</span>
							</div>
						</div>
						<div class="form-group row">
							<label for="staticEmail" class="col-sm-6 col-xs-5 col-form-label">Highest Qualification</label>
							<div class="col-sm-6 col-xs-7">
								<span class="per_old_fields">{this.state.employee.qualification}</span>
							</div>
						</div>
						<div class="form-group row">
							<label for="staticEmail" class="col-sm-6 col-xs-5 col-form-label">Technical Skill</label>
							<div class="col-sm-6 col-xs-7">
								<span class="per_old_fields">{this.state.employee.skill}</span>
							</div>
						</div>
					</div>
					<div class="col-md-6 col-xs-12">
						<div class="form-group row">
							<label for="staticEmail" class="col-sm-6 col-xs-5 col-form-label">Gender</label>
							<div class="col-sm-6 col-xs-7 radio_custom">
								<span class="per_old_fields">{this.state.employee.gender && this.state.employee.gender == 1 ? 'Male' : this.state.employee.gender && this.state.employee.gender == 2 ? 'Female' : ''}</span>
							</div>
						</div>
						<div class="form-group row">
							<label for="staticEmail" class="col-sm-6 col-xs-5 col-form-label">Address Line 2</label>
							<div class="col-sm-6 col-xs-7">
								<span class="per_old_fields">{this.state.employee.per_address_2}</span>
							</div>
						</div>
						<div class="form-group row">
							<label for="inputPassword" class="col-sm-6 col-xs-5 col-form-label">State</label>
							<div class="col-sm-6 col-xs-7">
								<span class="per_old_fields">{this.state.employee.per_state}</span>
							</div>
						</div>
						<div class="form-group row">
							<label for="staticEmail" class="col-sm-6 col-xs-5 col-form-label">Zip Code</label>
							<div class="col-sm-6 col-xs-7">
								<span class="per_old_fields">{this.state.employee.per_zipcode}</span>
							</div>
						</div>
						<div class="form-group row">
							<label for="staticEmail" class="col-sm-6 col-xs-5 col-form-label">Marital Status</label>
							<div class="col-sm-6 col-xs-7">
								<span class="per_old_fields">{this.state.employee.marital_status && this.state.employee.marital_status != 0 ? this.state.employee.marital_status : ''}</span>
							</div>
						</div>
						<div class="form-group row">
							<label for="staticEmail" class="col-sm-6 col-xs-5 col-form-label">Religion</label>
							<div class="col-sm-6 col-xs-7">
								<span class="per_old_fields">{this.state.employee.religion && this.state.employee.religion != 0 ? this.state.employee.religion : ''}</span>
							</div>
						</div>
						<div class="form-group row">
							<label for="staticEmail" class="col-sm-6 col-xs-5 col-form-label">Language Known</label>
							<div class="col-sm-6 col-xs-7">
								<span class="per_old_fields">{this.state.employee.language}</span>
							</div>
						</div>
						<div class="form-group row">
							<label for="staticEmail" class="col-sm-6 col-xs-5 col-form-label">Interest & Hobbies</label>
							<div class="col-sm-6 col-xs-7">
								<span class="per_old_fields">{this.state.employee.interest_hobbies}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}

	savePersonalInfo() {
		return (
			<div>
				<span class="job_title">Personal Information</span>
				{this.state.edit_access == 0 ? '' : this.getSavePersonalInfo()}
				<div class="row intra_form">
					<div class="col-md-6">
						<div class="form-group row">
							<label for="staticEmail" class="col-sm-3 col-form-label">Personal Email ID</label>
							<div class="col-sm-9 col-xs-12">
								<input type="text" id="per_email_save" name="per_email_save" class="form-control per_new_fields" onChange={this.onChange.bind(this, 'per_email')} value={this.state.employee.per_email} />
								<span class="error">{this.state.errors["per_email_save"]}</span>
								<span class="error">{this.state.registered_mail}</span>
							</div>
						</div>
						<div class="form-group row">
							<label for="staticEmail" class="col-sm-3 col-form-label">Address Line 1</label>
							<div class="col-sm-9 col-xs-12">
								<input type="text" id="per_address1_save" name="per_address1_save" class="form-control per_new_fields" onChange={this.onChange.bind(this, 'per_address_1')} value={this.state.employee.per_address_1} />
								<span class="error">{this.state.errors["per_address1_save"]}</span>
							</div>
						</div>
						<div className="form-group row">
							<label className="col-sm-3 col-form-label">Country</label>
							<div className="col-sm-9 col-xs-12">
								<select className="form-control" value={this.state.selectedCountry} onChange={this.handleCountryChange}>
									<option value="">Select Country</option>
									{this.state.countries.map(country => (
										<option key={country.iso2} value={country.iso2} name={country.name}>
											{country.name}
										</option>
									))}
								</select>
							</div>
						</div>
						<div className="form-group row">
							<label className="col-sm-3 col-form-label">City</label>
							<div className="col-sm-9 col-xs-12">
								<select className="form-control" value={this.state.selectedCity} onChange={this.handleCityChange} disabled={!this.state.selectedState}>
									<option value="">Select City</option>
									{this.state.cities.map(city => (
										<option key={city.id} value={city.name}>
											{city.name}
										</option>
									))}
								</select>
							</div>
						</div>
						<div class="form-group row">
							<label for="staticEmail" class="col-sm-3 col-form-label">Phone Number</label>
							<div class="col-sm-9 col-xs-12">
								<input type="text" id="per_phoneno_save" name="per_phoneno_save" class="form-control per_new_fields" onChange={this.onChange.bind(this, 'per_phoneno')} value={this.state.employee.per_phoneno} />
								<span class="error">{this.state.errors["per_phoneno_save"]}</span>
							</div>
						</div>
						<div class="form-group row">
							<label for="staticEmail" class="col-sm-3 col-form-label">Date Of Birth</label>
							<div class="col-sm-9 col-xs-12" name="date_of_birth">
								<span class="per_new_fields"><DatePicker
									onKeyDown={e => e.preventDefault()}
									name="per_dob_save"
									id="per_dob_save"
									dateFormat="dd/MM/yyyy"
									selected={this.state.date_of_birth}
									onChange={this.handleChangeDateOfBirth}
									peekNextMonth
									showMonthDropdown
									showYearDropdown
									dropdownMode="select"
								/></span>
								<span class="error">{this.state.errors["date_of_birth"]}</span>
							</div>
						</div>
						<div class="form-group row">
							<label for="staticEmail" class="col-sm-3 col-form-label">Highest Qualification</label>
							<div class="col-sm-9 col-xs-12">
								<input type="text" id="per_qualification_save" name="per_qualification_save" class="form-control per_new_fields" onChange={this.onChange.bind(this, 'qualification')} value={this.state.employee.qualification} />
							</div>
						</div>
						<div class="form-group row">
							<label for="staticEmail" class="col-sm-3 col-form-label">Technical Skill</label>
							<div class="col-sm-9 col-xs-12">
								<textarea type="text" id="per_skill_save" name="per_skill_save" class="form-control per_new_fields" onChange={this.onChange.bind(this, 'skill')} value={this.state.employee.skill}></textarea>
							</div>
						</div>
					</div>
					<div class="col-md-6">
						<div class="form-group row">
							<label for="staticEmail" class="col-sm-3 col-form-label">Gender</label>
							<div class="col-sm-9 col-xs-12 radio_custom">
								<div class="radio_custom per_new_fields">
									<div class="radio-inline feature-check">
										<input class="valid_fld" id="1" value="1" type="radio" name="per_gender_save" onChange={this.onChange.bind(this, 'gender')} checked={this.state.employee.gender === '1'} />
										<label for="1"><span></span>Male</label>
									</div>
									<div class="radio-inline feature-check">
										<input class="valid_fld" id="2" value="2" type="radio" name="per_gender_save" onChange={this.onChange.bind(this, 'gender')} checked={this.state.employee.gender === '2'} />
										<label for="2"><span></span>Female</label>
									</div>
								</div>
							</div>
						</div>
						<div class="form-group row">
							<label for="staticEmail" class="col-sm-3 col-form-label">Address Line 2</label>
							<div class="col-sm-9 col-xs-12">
								<input type="text" id="per_address2_save" name="per_address2_save" class="form-control per_new_fields" onChange={this.onChange.bind(this, 'per_address_2')} value={this.state.employee.per_address_2} />
							</div>
						</div>
						<div className="form-group row">
							<label className="col-sm-3 col-form-label">State</label>
							<div className="col-sm-9 col-xs-12">
								<select className="form-control" value={this.state.selectedState} onChange={this.handleStateChange} disabled={!this.state.selectedCountry}>
									{/* <select className={`${!this.state.selectedCountry ? "form-control bg-white list-group-item disabled" : "form-control"}`} value={this.state.selectedState} onChange={this.handleStateChange} disabled={!this.state.selectedCountry}> */}
									<option value="">Select State</option>
									{this.state.states.map(state => (
										<option key={state.iso2} value={state.iso2} name={state.name}>
											{state.name}
										</option>
									))}
								</select>
							</div>
						</div>
						<div class="form-group row">
							<label for="staticEmail" class="col-sm-3 col-form-label">Zip Code</label>
							<div class="col-sm-9 col-xs-12">
								<input type="text" id="per_zip_save" name="per_zip_save" class="form-control per_new_fields" onChange={this.onChange.bind(this, 'per_zipcode')} value={this.state.employee.per_zipcode} />
								<span class="error">{this.state.errors["per_zip_save"]}</span>
							</div>
						</div>
						<div class="form-group row">
							<label for="staticEmail" class="col-sm-3 col-form-label">Marital Status</label>
							<div class="col-sm-9 col-xs-12">
								<select class="form-control per_new_fields" id="per_marital_status" name="per_marital_status" onChange={this.onChange.bind(this, 'marital_status')} value={this.state.employee.marital_status}>
									<option value=""></option>
									<option value="Married">Married</option>
									<option value="Single">Single</option>
								</select>
							</div>
						</div>
						<div class="form-group row">
							<label for="staticEmail" class="col-sm-3 col-form-label">Religion</label>
							<div class="col-sm-9 col-xs-12">
								<select class="form-control per_new_fields" id="per_religion" name="per_religion" onChange={this.onChange.bind(this, 'religion')} value={this.state.employee.religion}>
									<option value=""></option>
									<option value="Hindu">Hindu</option>
									<option value="Muslim">Muslim</option>
									<option value="Sikh">Sikh</option>
									<option value="Christian">Christian</option>
									<option value="Jain">Jain</option>
									<option value="Buddhist">Buddhist</option>
									<option value="Prefer not to disclose">Prefer not to disclose</option>
								</select>
							</div>
						</div>
						<div class="form-group row">
							<label for="staticEmail" class="col-sm-3 col-form-label">Language Known</label>
							<div class="col-sm-9 col-xs-12">
								<input type="text" id="per_language_save" name="per_language_save" class="form-control per_new_fields" onChange={this.onChange.bind(this, 'language')} value={this.state.employee.language} />
							</div>
						</div>
						<div class="form-group row">
							<label for="staticEmail" class="col-sm-3 col-form-label">Interest & Hobbies</label>
							<div class="col-sm-9 col-xs-12">
								<textarea type="text" id="per_interest_save" name="per_interest_save" class="form-control per_new_fields" onChange={this.onChange.bind(this, 'interest_hobbies')} value={this.state.employee.interest_hobbies}></textarea>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}

	viewJobInfo() {
		if (this.state.loading) {
			return (
				<div class="loader-new"></div>
			)
		}
		else {
			return (
				<div>
					<div class="row">
						<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
							<div class="top-posit pb15">
								<div class="addmember-title">
									Job Information {this.state.edit_access == 0 ? '' : this.getSaveJobInfo()}
								</div>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
							<div class="top-info-box">
								<div class="info-box-content">
									<div class="imgboxing">
										<img src={this.state.employee.profile_image} />
									</div>
									<div class="info-box-allitem">
										<div class="info-name">{this.state.employee.name}</div>
										<div class="follow-div">
											<div class="text-item">
												<span>
													<svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
														<g clip-path="url(#clip0_337_229)">
															<path d="M13.8772 5.56909H3.20608C2.4694 5.56909 1.87219 6.16605 1.87219 6.90243V13.5691C1.87219 14.3055 2.4694 14.9024 3.20608 14.9024H13.8772C14.6139 14.9024 15.2111 14.3055 15.2111 13.5691V6.90243C15.2111 6.16605 14.6139 5.56909 13.8772 5.56909Z" stroke="#0063E1" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
															<path d="M11.2099 14.9023V4.23568C11.2099 3.88206 11.0694 3.54292 10.8193 3.29287C10.5691 3.04282 10.2298 2.90234 9.87606 2.90234H7.20828C6.85451 2.90234 6.51523 3.04282 6.26508 3.29287C6.01492 3.54292 5.87439 3.88206 5.87439 4.23568V14.9023" stroke="#0063E1" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
														</g>
														<defs>
															<clipPath id="clip0_337_229">
																<rect width="16.0067" height="16" fill="white" transform="translate(0.538818 0.902344)" />
															</clipPath>
														</defs>
													</svg>
												</span> {this.state.employee.position && this.state.employee.position != 0 ? this.state.employee.position : '--'}
											</div>
										</div>
										<div class="follow-div">
											<div class="text-item">
												<span>
													<svg xmlns="http://www.w3.org/2000/svg" height="17" width="17" viewBox="0 0 448 512" fill="#0063E1">
														<path d="M100.28 448H7.4V148.9h92.88zm-46.44-341a53.53 53.53 0 1 1 53.53-53.52 53.54 53.54 0 0 1-53.53 53.52zm394.34 341h-92.68V302.4c0-34.7-12.4-58.4-43.3-58.4-23.6 0-37.6 15.8-43.8 31.1-2.2 5.4-2.8 13-2.8 20.6V448h-92.78s1.2-271.3 0-299.1h92.78v42.4c-.2.3-.5.7-.7 1h.7v-1c12.3-19 34.3-46.1 83.5-46.1 60.9 0 106.6 39.8 106.6 125.4V448z" />
													</svg>
												</span>
												{this.state.employee.linkedin_url && this.state.employee.linkedin_url != 0 ?
													(
														<a target='_blank' href={this.state.employee.linkedin_url}><span>LinkedIn</span></a>
													)
													:
													'--'
												}
											</div>
										</div>
										{/*this.state.userId !== this.state.employee.id ? 
                                                            <div class="tab-system-view">
                                                                <div class="titl">Follow me:</div>
                                                                <div class="all-tag">
                                                                    <label class="switch">
                                                                        <input type="checkbox" id="work_follower" checked={(this.state.followType !=null && this.state.followType.includes(1)) ?"checked":""} onClick={(e) => this.followUser(e,this.state.userId,this.state.employee.id,1)} />
                                                                        <span class="slider round">
                                                                            <span class="one">
                                                                                <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                    <g clip-path="url(#clip0_204_2077)">
                                                                                    <path d="M13.436 4.78711H2.76937C2.03299 4.78711 1.43604 5.38406 1.43604 6.12044V12.7871C1.43604 13.5235 2.03299 14.1204 2.76937 14.1204H13.436C14.1724 14.1204 14.7694 13.5235 14.7694 12.7871V6.12044C14.7694 5.38406 14.1724 4.78711 13.436 4.78711Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                                                                    <path d="M10.7694 14.1206V3.45394C10.7694 3.10032 10.6289 2.76118 10.3788 2.51113C10.1288 2.26108 9.78966 2.12061 9.43603 2.12061H6.76937C6.41575 2.12061 6.07661 2.26108 5.82656 2.51113C5.57651 2.76118 5.43604 3.10032 5.43604 3.45394V14.1206" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                                                                    </g>
                                                                                    <defs>
                                                                                    <clipPath id="clip0_204_2077">
                                                                                    <rect width="16" height="16" fill="white" transform="translate(0.102539 0.120605)"></rect>
                                                                                    </clipPath>
                                                                                    </defs>
                                                                                </svg>                                                            
                                                                            </span>
                                                                            Work</span>
                                                                    </label>
                                                                    <label class="switch sml-switch">
                                                                        <input id="life_follower" type="checkbox" class="followerType" value ="2" checked={(this.state.followType!=null && this.state.followType.includes(2)) ?"checked":""} onClick={(e) => this.followUser(e,this.state.userId,this.state.employee.id,2)}/>
                                                                        <span class="slider round">
                                                                            <span class="two">
                                                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                    <path d="M12.6025 13.7456V12.4956C12.6025 11.8326 12.3391 11.1967 11.8703 10.7278C11.4015 10.259 10.7656 9.99561 10.1025 9.99561H5.10254C4.4395 9.99561 3.80361 10.259 3.33477 10.7278C2.86593 11.1967 2.60254 11.8326 2.60254 12.4956V13.7456" stroke="#202223" stroke-opacity="1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                                                                    <path d="M7.60254 7.49561C8.98325 7.49561 10.1025 6.37632 10.1025 4.99561C10.1025 3.61489 8.98325 2.49561 7.60254 2.49561C6.22183 2.49561 5.10254 3.61489 5.10254 4.99561C5.10254 6.37632 6.22183 7.49561 7.60254 7.49561Z" stroke="#202223" stroke-opacity="1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                                                                </svg>                                                                                                                        
                                                                            </span>
                                                                            Life</span>
                                                                    </label> 
                                                                    <label class="switch mdl-switch">
                                                                        <input type="checkbox" />
                                                                        <span class="slider round">
                                                                            <span class="three">
                                                                                <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                    <path d="M21.1857 2.87055C20.3079 3.48973 19.336 3.96331 18.3074 4.27305C17.7553 3.63826 17.0216 3.18835 16.2055 2.98414C15.3894 2.77994 14.5302 2.83131 13.7443 3.13129C12.9583 3.43128 12.2834 3.96541 11.8109 4.66145C11.3384 5.35749 11.0911 6.18185 11.1024 7.02305V7.93971C9.49146 7.98148 7.89521 7.62421 6.4558 6.8997C5.01639 6.1752 3.7785 5.10596 2.85238 3.78721C2.85238 3.78721 -0.814291 12.0372 7.43571 15.7039C5.54786 16.9853 3.29894 17.6279 1.01904 17.5372C9.26904 22.1205 19.3524 17.5372 19.3524 6.99555C19.3515 6.74021 19.327 6.48551 19.279 6.23471C20.2146 5.31208 20.8748 4.1472 21.1857 2.87055Z" fill="#09B9F2"></path>
                                                                                </svg>                                                                                                                                                                                    
                                                                            </span>
                                                                            Twitter</span>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                              :""*/}
									</div>
								</div>
							</div>
						</div>
					</div>
					{/*<Followers loggedInUser={this.state.userId} all_user_list={this.state.all_user_list} parent={this} flowtwoval={this.state.flowtwoval} flowoneval={this.state.flowoneval} searchKeyWords = {this.searchKeywordsFilter} relationType = {this.state.relationType} followerData={this.state.followerData} followerDataCount={this.state.followerDataCount}  />*/}
					<div class="row intra_form job-info">
						<div class="col-md-6 col-xs-12">
							<div class="form-group row">
								<label for="staticEmail" class="col-sm-6 col-xs-6 col-form-label">Employee ID</label>
								<div class="col-sm-6 col-xs-6">
									<span class="emp_old_fields">{this.state.employee.muvi_employee_id}</span>
								</div>
							</div>
							{/* <div class="form-group row">
								<label for="inputPassword" class="col-sm-3 col-xs-5 col-form-label">Skype ID</label>
								<div class="col-sm-9 col-xs-7">
									<span class="emp_old_fields">{this.state.employee.skype_id}</span>
								</div>
							</div> */}
							<div class="form-group row">
								<label for="staticEmail" class="col-sm-6 col-xs-6 col-form-label">Joined MUVI on</label>
								<div class="col-sm-6 col-xs-6">
									<span class="emp_old_fields">{this.state.employee.date_of_joining != '' && this.state.employee.date_of_joining != '0000-00-00' ? this.state.employee.dateofjoining : ''}</span>
								</div>
							</div>
							<div class="form-group row">
								<label for="staticEmail" class="col-sm-6 col-xs-5 col-form-label">Career started on</label>
								<div class="col-sm-6 col-xs-7">
									<span class="emp_old_fields">{this.state.employee.date_of_previousexp != '0000-00-00' ? this.state.employee.dateofpreviousexp : '--'}</span>
								</div>
							</div>
							<div class="form-group row">
								<label for="inputPassword" class="col-sm-6 col-xs-6 col-form-label">Permission</label>
								<div class="col-sm-6 col-xs-6">
									{this.state.permissions.length > 0 ?
										<div>
											{this.state.permissions.slice(0, this.state.employee.itemsToShow_perm).map((permission, i) => {
												return <div class="mab-bootstrap-taginput-tag">{permission.name}
													{this.state.hr_permission == 'yes' ?
														<React.Fragment>
															<div class="" data-toggle="modal" data-target={`#deletePermissionModal${permission.id}`}>
																<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg"
																	><path d="M12.25 4.25L4.25 12.25" stroke="#5A738E" stroke-opacity="0.6" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" /><path d="M4.25 4.25L12.25 12.25" stroke="#888888" stroke-opacity="0.6" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
																</svg>
															</div>
															<this.DeleteConfirmationModal
																id={`deletePermissionModal${permission.id}`}
																message={`Are you sure want to remove the permission ${permission.name}?`}
																onConfirm={() => this.ClosePermission(permission)}
															/>
														</React.Fragment>
														: ''}
												</div>
											})}
											{(this.state.permissions.length > this.state.employee.itemsToShow_perm || this.state.employee.perm_collapse) ?
												<div className="show-more-tag" onClick={() => this.showMorePermissions(this.state.permissions.length, this.state.employee.itemsToShow_perm, 'perm')}>
													{this.state.employee.perm_collapse ? <span> Show less</span> : <span>+ {this.state.permissions.length - this.state.employee.itemsToShow_perm + ' More'}</span>}
												</div> : ""
											}
										</div>
										: this.state.hr_permission != 'yes' && '--'}
									{this.state.hr_permission == 'yes' && (
										<this.AddValuesModal
											id="AddPermissions"
											heading="Add Permissions"
											options={this.state.permissions_data}
											disabledOptions={this.state.permissions}
											onSubmit={this.addPermissions}
										/>
									)}
									{/*this.state.permissions.length > 0 ?
                                                                <div>
                                        {this.state.permissions.map((permission, i) => {
                                            return <div class="mab-bootstrap-taginput-tag">{permission.name}
											{this.state.hr_permission == 'yes' ?
											<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" 
                                            onClick={() => { if (window.confirm('Are you sure want to remove'))this.ClosePermission(permission) } }
                                                                                ><path d="M12.25 4.25L4.25 12.25" stroke="#5A738E" stroke-opacity="0.6" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/><path d="M4.25 4.25L12.25 12.25" stroke="#888888" stroke-opacity="0.6" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
                                                                            </svg> : ''}
                                            </div>

                                            })}
                                            
                                                                </div> : '--'*/}
								</div>
							</div>
							<div class="form-group row" >
								<label for="staticEmail" class="col-sm-6 col-xs-6 col-form-label">POD</label>
								<div class="col-sm-6 col-xs-6">
									{this.state.employee.total_pod > 0 ?
										<div>
											{this.state.employee.pod.slice(0, this.state.employee.itemsToShow_pod).map((pod, i) => {
												return <div class="mab-bootstrap-taginput-tag">{pod.name}</div>
											})}
											{(this.state.employee.pod.length > this.state.employee.itemsToShow_pod || this.state.employee.pod_collapse) ?
												<div className="show-more-tag" onClick={() => this.showMorePermissions(this.state.employee.pod.length, this.state.employee.itemsToShow_pod, "pod")}>
													{this.state.employee.pod_collapse ? <span> Show less</span> : <span>+ {this.state.employee.pod.length - this.state.employee.itemsToShow_pod + ' More'}</span>}
												</div> : ""
											}
											{/*this.state.employee.pod.map((pod, i) => {
                                            return <div class="mab-bootstrap-taginput-tag">{pod.name}
                                            </div>
                                                                        })*/}
										</div> : '--'}
								</div>
							</div>
							<div class="form-group row" >
								<label for="staticEmail" class="col-sm-6 col-xs-6 col-form-label">Corp</label>
								<div class="col-sm-6 col-xs-6">
									{this.state.employee.corp.length > 0 ?
										<div>
											{this.state.employee.corp.slice(0, this.state.employee.itemsToShow_corp).map((corp, i) => {
												return <div class="mab-bootstrap-taginput-tag">{corp.name}</div>
											})}
											{(this.state.employee.corp.length > this.state.employee.itemsToShow_corp || this.state.employee.corp_collapse) ?
												<div className="show-more-tag" onClick={() => this.showMorePermissions(this.state.employee.corp.length, this.state.employee.itemsToShow_corp, "corp")}>
													{this.state.employee.corp_collapse ? <span> Show less</span> : <span>+ {this.state.employee.corp.length - this.state.employee.itemsToShow_corp + ' More'}</span>}
												</div> : ""
											}
											{/*this.state.employee.corp.map((corp, i) => {
                                                                        return <div class="mab-bootstrap-taginput-tag">{corp.name}</div>
                                                                    })*/}
										</div> : '--'}
								</div>
							</div>

							<div class="form-group row" >
								<label for="staticEmail" class="col-sm-6 col-xs-6 col-form-label">Primary Groups</label>
								<div class="col-sm-6 col-xs-6">
									{this.state.selected_group_id.length > 0 ?
										<div>
											{this.state.selected_group_id.slice(0, this.state.employee.itemsToShow_pg).map((primary, i) => {
												return <div class="mab-bootstrap-taginput-tag">{primary.name}
													{this.state.hr_permission == 'yes' ?
														<React.Fragment>
															<div class="" data-toggle="modal" data-target={`#deletePrimaryModal${primary.id}`}>
																<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg"
																	><path d="M12.25 4.25L4.25 12.25" stroke="#5A738E" stroke-opacity="0.6" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" /><path d="M4.25 4.25L12.25 12.25" stroke="#888888" stroke-opacity="0.6" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
																</svg>
															</div>
															<this.DeleteConfirmationModal
																id={`deletePrimaryModal${primary.id}`}
																message={`Are you sure want to remove the Primary Group ${primary.name}?`}
																onConfirm={() => this.CloseMemberFromGroup(this.state.employee.id, primary.id, 1)}
															/>
														</React.Fragment> : ''}
												</div>
											})}
											{(this.state.selected_group_id.length > this.state.employee.itemsToShow_pg || this.state.employee.primary_collapse) ?
												<div className="show-more-tag" onClick={() => this.showMorePermissions(this.state.selected_group_id.length, this.state.employee.itemsToShow_pg, "primarygrp")}>
													{this.state.employee.primary_collapse ? <span> Show less</span> : <span>+ {this.state.selected_group_id.length - this.state.employee.itemsToShow_pg + ' More'}</span>}
												</div> : ""
											}

										</div> : (this.state.hr_permission != 'yes') && '--'}
									{
										this.state.hr_permission == 'yes' && (
											<this.AddValuesModal
												id="AddPrimaryGroups"
												heading="Add Primary Groups"
												options={this.state.all_groups}
												disabledOptions={[
													...(this.state.selected_group_id || []),
													...(this.state.selected_group_listener || []),
												]}
												onSubmit={this.addPrimaryGroups}
											/>
										)
									}
								</div>
							</div>
							<div class="form-group row" >
								<label for="staticEmail" class="col-sm-6 col-xs-6 col-form-label">Listener Groups</label>
								<div class="col-sm-6 col-xs-6">
									{this.state.selected_group_listener.length > 0 ?
										<div>
											{this.state.selected_group_listener.slice(0, this.state.employee.itemsToShow_lg).map((listener, i) => {
												return <div class="mab-bootstrap-taginput-tag">{listener.name}
													{this.state.hr_permission == 'yes' ?
														<React.Fragment>
															<div class="" data-toggle="modal" data-target={`#deleteListenerModal${listener.id}`}>
																<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg"
																	><path d="M12.25 4.25L4.25 12.25" stroke="#5A738E" stroke-opacity="0.6" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" /><path d="M4.25 4.25L12.25 12.25" stroke="#888888" stroke-opacity="0.6" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
																</svg>
															</div>
															<this.DeleteConfirmationModal
																id={`deleteListenerModal${listener.id}`}
																message={`Are you sure want to remove the Listener Group ${listener.name}?`}
																onConfirm={() => this.CloseMemberFromGroup(this.state.employee.id, listener.id, 0)}
															/>
														</React.Fragment> : ''}
												</div>
											})}
											{(this.state.selected_group_listener.length > this.state.employee.itemsToShow_lg || this.state.employee.listener_collapse) ?
												<div className="show-more-tag" onClick={() => this.showMorePermissions(this.state.selected_group_listener.length, this.state.employee.itemsToShow_lg, "listenergrp")}>
													{this.state.employee.listener_collapse ? <span> Show less</span> : <span>+ {this.state.selected_group_listener.length - this.state.employee.itemsToShow_lg + ' More'}</span>}
												</div> : ""
											}
										</div> : (this.state.hr_permission != 'yes') && '--'}
										{
											this.state.hr_permission == 'yes' && (
												<this.AddValuesModal
													id="AddListenerGroups"
													heading="Add Listener Groups"
													options={this.state.all_groups}
													disabledOptions={[
														...(this.state.selected_group_id || []),
														...(this.state.selected_group_listener || []),
													]}
													onSubmit={this.addListenerGroups}
												/>
											)
										}
								</div>
							</div>
						</div>
						<div class="col-md-6 col-xs-12">
							<div class="form-group row">
								<label for="inputPassword" class="col-sm-6 col-xs-6 col-form-label">Email ID</label>
								<div class="col-sm-6 col-xs-6">
									<span class="emp_old_fields">{this.state.employee.email}</span>
								</div>
							</div>
							<div class="form-group row">
								<label for="inputPassword" class="col-sm-6 col-xs-5 col-form-label">Department</label>
								<div class="col-sm-6 col-xs-7">
									{this.state.employee.total_department > 0 ?
										<div>
											{this.state.employee.department.slice(0, this.state.employee.itemsToShow_dept).map((department, i) => {
												return <div class="mab-bootstrap-taginput-tag">{department.name}</div>
											})}
											{(this.state.employee.total_department > this.state.employee.itemsToShow_dept || this.state.employee.department_collapse) ?
												<div className="show-more-tag" onClick={() => this.showMorePermissions(this.state.employee.total_department, this.state.employee.itemsToShow_dept, "dept")}>
													{this.state.employee.department_collapse ? <span> Show less</span> : <span>+ {this.state.employee.total_department - this.state.employee.itemsToShow_dept + ' More'}</span>}
												</div> : ""
											}
											{/*this.state.employee.department.map((department, i) => {
                                                                                return <div class="mab-bootstrap-taginput-tag">{department.name}</div>
                                                                                })*/}
										</div> : '--'}
									{/* <span class="emp_old_fields">{this.state.employee.department && this.state.employee.department != 0 ? this.state.employee.department : '--'}</span> */}
								</div>
							</div>
							<div class="form-group row">
								<label for="staticEmail" class="col-sm-6 col-xs-5 col-form-label">Manager</label>
								<div class="col-sm-6 col-xs-7">
									<span class="emp_old_fields">{this.state.manager}</span>
								</div>
							</div>
							{/*<div class="form-group row">
								<label for="staticEmail" class="col-sm-6 col-xs-5 col-form-label">Functional Lead</label>
								<div class="col-sm-6 col-xs-7">
									<span class="emp_old_fields">{this.state.employee.functional_manager?this.state.functional_manager:'--'}</span>
								</div>
							</div>*/}
							<div class="form-group row">
								<label for="staticEmail" class="col-sm-6 col-xs-5 col-form-label">Work Location</label>
								<div class="col-sm-6 col-xs-7">
									<span class="emp_old_fields">{this.state.employee.worklocation}</span>
								</div>
							</div>
							<div class="form-group row">
								<label for="staticEmail" class="col-sm-6 col-xs-5 col-form-label">Phone Number</label>
								<div class="col-sm-6 col-xs-7">
									<span class="emp_old_fields">{this.state.employee.per_phoneno ? this.state.employee.per_phoneno : '--'}</span>
								</div>
							</div>
							<div class="form-group row">
								<label for="staticEmail" class="col-sm-6 col-xs-5 col-form-label">Level</label>
								<div class="col-sm-6 col-xs-7">
									<span class="emp_old_fields">{this.state.employee.level ? this.state.employee.level : '--'}</span>
								</div>
							</div>
							{/*
							<div class="form-group row">
								<label for="staticEmail" class="col-sm-3 col-xs-5 col-form-label">Previous Relevant Experience</label>
								<div class="col-sm-9 col-xs-7">
									<span class="emp_old_fields">{this.state.employee.exp}</span>
								</div>
							</div>*/}
							<div class="form-group row">
								<label for="staticEmail" class="col-sm-6 col-xs-5 col-form-label">Muvi Experience</label>
								<div class="col-sm-6 col-xs-7">
									<span class="emp_old_fields">{this.state.employee.currnt_exp}</span>
								</div>
							</div>

							<div class="form-group row">
								<label for="staticEmail" class="col-sm-6 col-xs-5 col-form-label">Total Experience</label>
								<div class="col-sm-6 col-xs-7">
									<span class="emp_old_fields">{this.state.employee.tot_exp}</span>
								</div>
							</div>
							<div class="form-group row">
								<label for="staticEmail" class="col-sm-6 col-xs-5 col-form-label">Add snippet</label>
								<div class="col-sm-6 col-xs-7">
									<span class="emp_old_fields">{this.state.employee.snipeet_add_user == 1 ? 'Mandatory' : 'Optional'}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			)
		}
	}

	saveJobInfo() {
		var pods = this.state.selected_pods;
		$(document).ready(function () {
			function readURL(input) {
				if (input.files && input.files[0]) {
					var reader = new FileReader();

					reader.onload = function (e) {
						$('#blah').attr('src', e.target.result);
					}

					reader.readAsDataURL(input.files[0]);
				}
			}
			/*$("#image-preview .fa").on('click', function () {
				$("#image-preview input").click();
			});
			$("#imgInp").change(function () {
				readURL(this);
								this.setState({imageLoader:1});
			});*/
		});
		return (
			<div>
				<span class="job_title">Job Information</span>
				{this.state.edit_access == 0 ? '' : this.getEditJobInfo()}
				<div class="row intra_form top emp_info_img">
					<div id="image-preview" class="emp_info_img" onChange={this.uploadProfileImage}>
						<input type="file" class="imgInp" name="imgInp" id="imgInp" accept="image/*" />
						{this.state.imageLoader ?
							<div class="imgloader-new"></div>
							:
							<img id="blah" src={this.state.employee.medium_image && this.state.employee.attachment_url ? this.state.employee.attachment_url + this.state.employee.medium_image : Profile_img} alt="your image" />
						}
						<i class="fa fa-cloud-upload-alt"></i>
					</div>
					<div class="empolyee_info">
						<div class="form-group row">
							<label for="staticEmail" class="col-sm-3 col-form-label">Name<span class="star">*</span></label>
							<div class="col-sm-9 col-xs-12">
								<input type="text" id="emp_name_save" name="emp_name_save" class="form-control emp_new_fields" onChange={this.onChange.bind(this, 'name')} value={this.state.employee.name} />
								<span class="error">{this.state.errors["emp_name_save"]}</span>
							</div>
						</div>
						<div class="form-group row">
							<label for="emp_position_save" class="col-sm-3 col-form-label">Designation<span class="star">*</span></label>
							{
								(this.state.hr_permission == 'yes') ? (
									<div class="col-sm-9 col-xs-12">
										<select class="form-control emp_new_fields" id="emp_position_save" name="emp_position_save" value={this.state.employee.position} onChange={this.onChange.bind(this, 'position')}>
											{
												this.state.hiring_profile.map((hiring_profile, key) =>
													<option value={hiring_profile.name}>{hiring_profile.name}</option>
												)
											}
										</select>
										<span class="error">{this.state.errors["emp_position_save"]}</span>
									</div>
								) : (
									<div class="col-sm-9 col-xs-12">
										<span class="emp_new_fields">{this.state.employee.position}</span>
									</div>
								)
							}
						</div>
						<div class="form-group row">
							<label for="emp_linkedin_save" class="col-sm-3 col-form-label">LinkedIn URL<span class="star">*</span></label>
							{
								<div class="col-sm-9 col-xs-12">
									<input type="text" id="emp_linkedin_save" name="emp_linkedin_save" class="form-control emp_new_fields" onChange={this.onChange.bind(this, 'linkedin_url')} value={this.state.employee.linkedin_url} />
									<span class="error">{this.state.errors["emp_linkedin_save"]}</span>
								</div>
							}
						</div>
					</div>
				</div>
				<div class="profile_img_err error">{this.state.errors.file_extension}</div>
				<div class="row intra_form">
					<div class="col-md-6 col-xs-12">
						<div class="form-group row">
							<label for="staticEmail" class="col-sm-3 col-form-label">Employee ID<span class="star">*</span></label>
							<div class="col-sm-9 col-xs-12">
								<input type="text" id="emp_id_save" name="emp_id_save" class="form-control emp_new_fields" onChange={this.onChange.bind(this, 'muvi_employee_id')} value={this.state.employee.muvi_employee_id} readOnly={this.state.hr_permission != 'yes'} />
								<span class="error">{this.state.errors["emp_id_save"]}</span>
							</div>
						</div>
						<div class="form-group row">
							<label for="staticEmail" class="col-sm-3 col-form-label">Joined MUVI on</label>
							<div class="col-sm-9 col-xs-12">
								<span class="emp_new_fields">{this.state.employee.date_of_joining != '' && this.state.employee.date_of_joining != '0000-00-00' ? this.state.employee.dateofjoining : ''}</span>
							</div>
						</div>
						{this.state.hr_permission == 'yes' ?
							<div class="form-group row">
								<label for="staticEmail" class="col-sm-3 col-form-label">Career started on</label>
								<div class="col-sm-9 col-xs-12">
									<span class="per_new_fields">
										<DatePicker
											onKeyDown={e => e.preventDefault()}
											dateFormat="dd/MM/yyyy"
											selected={this.state.date_of_previousexp}
											onChange={this.handleChangePreviousexp}
											peekNextMonth
											showMonthDropdown
											showYearDropdown
											dropdownMode="select"
											maxDate={this.state.date_of_joining} />
									</span>
								</div>
							</div>
							: ''}
						{/* {this.state.hr_permission == 'yes' ? <div class="form-group row">
							<label for="inputPassword" class="col-sm-3 col-form-label">Permission<span class="star">*</span></label>
							<div class="col-sm-9 col-xs-12">
								<select class="form-control" name="project" onChange={this.handlePermissionChange}>
									<option value="">Select Permission</option>
									{this.state.permissions_data.map((permissions, key) =>
										<option disabled={this.state.selected_permission ? this.state.selected_permission.find(item => item.id === permissions.id) : ''} value={permissions.id + '/' + permissions.name}>{permissions.name}</option>
									)}
								</select>
								<span class="error">{this.state.errors["emp_project_save"]}</span>
							</div>
						</div> : ''} */}
						{this.state.hr_permission == 'yes' ?
							<div class="form-group row" >
								<label for="staticEmail" class="col-sm-3 col-form-label">Permission</label>
								<div class="col-xs-6 col-sm-6 col-md-8 col-lg-8">
									<div>
										{
											this.state.permissions.length > 0 ? (
												this.state.selected_permission.map((permission, i) => {
													return <div class="mab-bootstrap-taginput-tag">{permission.name}
														{this.state.hr_permission == 'yes' ?
															<React.Fragment>
																<div class="" data-toggle="modal" data-target={`#deletePermissionEditModal${permission.id}`}>
																	<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg"
																		><path d="M12.25 4.25L4.25 12.25" stroke="#5A738E" stroke-opacity="0.6" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" /><path d="M4.25 4.25L12.25 12.25" stroke="#888888" stroke-opacity="0.6" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
																	</svg>
																</div>
																<this.DeleteConfirmationModal
																	id={`deletePermissionEditModal${permission.id}`}
																	message={`Are you sure want to remove the permission ${permission.name}?`}
																	onConfirm={() => this.ClosePermission(permission)}
																/>
															</React.Fragment>
														: ''}
													</div>

												})
											) : this.state.hr_permission != 'yes' ? '--' : ''
										}
										{this.state.hr_permission == 'yes' && (
											<this.AddValuesModal
												id="AddPermissionsEdit"
												heading="Add Permissions"
												options={this.state.permissions_data}
												disabledOptions={this.state.permissions}
												onSubmit={this.addPermissions}
											/>
										)}
									</div>
								</div>
							</div> :
							''}
						<div class="form-group row" >
							<label for="staticEmail" class="col-sm-3 col-form-label">POD</label>
							<div className="col-sm-9 col-xs-12">
								{this.state.groupPod.length > 0 ?
									<div>
										{this.state.groupPod.map((pod, i) => {
											return <div class="mab-bootstrap-taginput-tag">{pod.name}
											</div>

										})}

									</div> : '--'}
							</div>
						</div>
						<div class="form-group row" >
							<label for="staticEmail" class="col-sm-3 col-xs-5 col-form-label">Corp</label>
							<div class="col-sm-9 col-xs-7">

								{this.state.groupCorp.length > 0 ?
									<div>
										{this.state.groupCorp.map((corp, i) => {

											return <div class="mab-bootstrap-taginput-tag">{corp.name}
											</div>

										})}
									</div> : '--'}
							</div>
						</div>
						{console.log(2041, this.state.hr_permission)}
						{this.state.hr_permission == 'yes' ?
							<div>
								{/* <div class="form-group row" >
									<label for="staticEmail" class="col-sm-3 col-form-label">Primary Groups</label>
									<div class="col-sm-9 col-xs-12">
										<select class="form-control" name="" onChange={this.handleGroupChange}>
											<option aria-label="None" value="" />
											<optgroup label="Department" >
												{
													this.state.department_names.map((department_name, key) =>
														<option disabled={this.state.group ? this.state.group.find(item => item.id === department_name.id) : ''} value={department_name.id + '/' + department_name.name + '/' + department_name.email + '/' + department_name.group_type}>{department_name.name}</option>
													)
												}
											</optgroup>
											<optgroup label="POD">
												{
													this.state.pod_names.map((pod_name, key) =>
														<option disabled={this.state.group ? this.state.group.find(item => item.id === pod_name.id) : ''} value={pod_name.id + '/' + pod_name.name + '/' + pod_name.email + '/' + pod_name.group_type}>{pod_name.name}</option>
													)
												}
											</optgroup>
											<optgroup label="Corp">
												{
													this.state.crop_names.map((crop_name, key) =>
														<option disabled={this.state.group ? this.state.group.find(item => item.id === crop_name.id) : ''} value={crop_name.id + '/' + crop_name.name + '/' + crop_name.email + '/' + crop_name.group_type}>{crop_name.name}</option>
													)
												}
											</optgroup>
											<optgroup label="Troop">
												{
													this.state.troop_names.map((troop_name, key) =>
														<option disabled={this.state.group ? this.state.group.find(item => item.id === troop_name.id) : ''} value={troop_name.id + '/' + troop_name.name + '/' + troop_name.email + '/' + troop_name.group_type}>{troop_name.name}</option>
													)
												}
											</optgroup>
											<optgroup label="Email Group">
												{
													this.state.email_names.map((email_name, key) =>
														<option disabled={this.state.group ? this.state.group.find(item => item.id === email_name.id) : ''} value={email_name.id + '/' + email_name.name + '/' + email_name.email + '/' + email_name.group_type}>{email_name.name}</option>
													)
												}
											</optgroup>

										</select>
									</div>
								</div> */}
								<div class="form-group row" >
									<label for="staticEmail" class="col-sm-3 col-form-label">Primary Groups</label>
									<div class="col-sm-9 col-xs-12">
									{this.state.selected_group_id.length > 0 ?
										(this.state.selected_group_id.map((primary, i) => {
											return <div class="mab-bootstrap-taginput-tag">{primary.name}
												<React.Fragment>
													<div class="" data-toggle="modal" data-target={`#deletePrimaryEditModal${primary.id}`}>
														<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg"
															><path d="M12.25 4.25L4.25 12.25" stroke="#5A738E" stroke-opacity="0.6" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" /><path d="M4.25 4.25L12.25 12.25" stroke="#888888" stroke-opacity="0.6" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
														</svg>
													</div>
													<this.DeleteConfirmationModal
														id={`deletePrimaryEditModal${primary.id}`}
														message={`Are you sure want to remove the Primary Group ${primary.name}?`}
														onConfirm={() => this.CloseMemberFromGroup(this.state.employee.id, primary.id, 1)}
													/>
												</React.Fragment>
											</div>

										}))
										: ''}
										{
											this.state.hr_permission == 'yes' && (
												<this.AddValuesModal
												id="AddPrimaryGroupsEdit"
													heading="Add Primary Groups"
													options={this.state.all_groups}
													disabledOptions={[
														...(this.state.selected_group_id || []),
														...(this.state.selected_group_listener || []),
													]}
													onSubmit={this.addPrimaryGroups}
												/>
											)
										}
									</div>
								</div>
							</div>
							:
							<div class="form-group row" >
								<label for="staticEmail" class="col-sm-3 col-xs-3 col-form-label">Primary Groups</label>
								<div class="col-sm-6 col-xs-6">
									{this.state.selected_group_id.length > 0 ?
										<div>
											{this.state.selected_group_id.map((primary, i) => {
												return <div class="mab-bootstrap-taginput-tag">{primary.name}</div>
											})}
										</div> : '--'}
								</div>
							</div>
						}
						{this.state.hr_permission == 'yes' ?
							<div>
								{/* <div class="form-group row" >
									<label for="staticEmail" class="col-sm-3 col-form-label">Listener Groups</label>
									<div class="col-sm-9 col-xs-12">
										<select class="form-control" placeholder="Select Role" name="" onChange={this.handleListenerGroupChange}>
											<option aria-label="None" value="" />
											<optgroup label="Department">
												{this.state.department_names.map((department_name, key) =>
													<option disabled={this.state.group ? this.state.group.find(item => item.id === department_name.id) : ''} value={department_name.id + '/' + department_name.name + '/' + department_name.email + '/' + department_name.group_type}>{department_name.name}</option>
												)}
											</optgroup>

											<optgroup label="POD">
												{this.state.pod_names.map((pod_name, key) =>
													<option disabled={this.state.group ? this.state.group.find(item => item.id === pod_name.id) : ''} value={pod_name.id + '/' + pod_name.name + '/' + pod_name.email + '/' + pod_name.group_type}>{pod_name.name}</option>
												)}
											</optgroup>
											<optgroup label="Corp">
												{this.state.crop_names.map((crop_name, key) =>
													<option disabled={this.state.group ? this.state.group.find(item => item.id === crop_name.id) : ''} value={crop_name.id + '/' + crop_name.name + '/' + crop_name.email + '/' + crop_name.group_type}>{crop_name.name}</option>
												)}
											</optgroup>
											<optgroup label="Troop">
												{this.state.troop_names.map((troop_name, key) =>
													<option disabled={this.state.group ? this.state.group.find(item => item.id === troop_name.id) : ''} value={troop_name.id + '/' + troop_name.name + '/' + troop_name.email + '/' + troop_name.group_type}>{troop_name.name}</option>
												)}
											</optgroup>
											<optgroup label="Email Group">
												{this.state.email_names.map((email_name, key) =>
													<option disabled={this.state.group ? this.state.group.find(item => item.id === email_name.id) : ''} value={email_name.id + '/' + email_name.name + '/' + email_name.email + '/' + email_name.group_type}>{email_name.name}</option>
												)}
											</optgroup>
										</select>
									</div>
								</div> */}
								<div class="form-group row" >
									<label for="staticEmail" class="col-sm-3 col-form-label">Listener Groups</label>
									<div class="col-sm-9 col-xs-12">
									{this.state.selected_group_listener.length > 0 ?
										(this.state.selected_group_listener.map((listener, i) => {
											return <div class="mab-bootstrap-taginput-tag">{listener.name}
												<React.Fragment>
													<div class="" data-toggle="modal" data-target={`#deleteListenerModal${listener.id}`}>
														<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg"
															><path d="M12.25 4.25L4.25 12.25" stroke="#5A738E" stroke-opacity="0.6" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" /><path d="M4.25 4.25L12.25 12.25" stroke="#888888" stroke-opacity="0.6" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
														</svg>
													</div>
													<this.DeleteConfirmationModal
														id={`deleteListenerModal${listener.id}`}
														message={`Are you sure want to remove the Listener Group ${listener.name}?`}
														onConfirm={() => this.CloseMemberFromGroup(this.state.employee.id, listener.id, 0)}
													/>
												</React.Fragment>
											</div>

										}))
										: ''}
										{
											this.state.hr_permission == 'yes' && (
												<this.AddValuesModal
													id="AddListenerGroupsEdit"
													heading="Add Listener Groups"
													options={this.state.all_groups}
													disabledOptions={[
														...(this.state.selected_group_id || []),
														...(this.state.selected_group_listener || []),
													]}
													onSubmit={this.addListenerGroups}
												/>
											)
										}
										</div>
								</div>
							</div>
							:
							<div class="form-group row" >
								<label for="staticEmail" class="col-sm-3 col-xs-3 col-form-label">Listener Groups</label>
								<div class="col-sm-6 col-xs-6">
									{this.state.selected_group_listener.length > 0 ?
										<div>
											{this.state.selected_group_listener.map((listener, i) => {
												return <div class="mab-bootstrap-taginput-tag">{listener.name}</div>
											})}
										</div> : '--'}
								</div>
							</div>
						}
						<span class="error">{this.state.registered_mail}</span>
					</div>
					<div class="col-md-6 col-xs-12">
						<div class="form-group row">
							<label for="staticEmail" class="col-sm-3 col-form-label">Email ID<span class="star">*</span></label>
							<div class="col-sm-9 col-xs-12">
								<input type="text" id="emp_email_save" name="emp_email_save" class="form-control emp_new_fields" onChange={this.onChange.bind(this, 'email')} value={this.state.employee.email} readOnly />
								<span class="error">{this.state.errors["emp_email_save"]}</span>
							</div>
						</div>
						<div class="form-group row">
							<label for="inputPassword" class="col-sm-3 col-form-label">Department<span class="star">*</span></label>
							<div class="col-sm-9 col-xs-12">
								{this.state.groupDepartment.length > 0 ?
									<div>
										{this.state.groupDepartment.map((department, i) => {

											return <div class="mab-bootstrap-taginput-tag">{department.name}

											</div>

										})}

									</div> : '--'}


							</div>
						</div>
						{this.state.hr_permission == 'yes' ? <div class="form-group row">
							<label for="staticEmail" class="col-sm-3 col-form-label">Manager<span class="star">*</span></label>
							<div class="col-sm-9 col-xs-12">
								<div class="filter" name="manager">
									<MuiThemeProvider muiTheme={getMuiTheme()} class="form-control">
										<AutoComplete
											onUpdateInput={this.handleUpdateInput_manager}
											onNewRequest={this.onNewRequest_manager.bind(this)}
											onClick={this.handleUpdateInput_manager}
											fullWidth={true}
											placeholder="Type here to manager Name"
											filter={AutoComplete.caseInsensitiveFilter}
											dataSource={this.state.search}
											dataSourceConfig={dataSourceConfig}
											errorStyle={{ bottom: 0 }}
											errorText={this.state.errorText1}
											maxSearchResults={500}
											className="ticket_search_box"
											searchText={this.state.searchText1}
											openOnFocus={true}
											menuStyle={{ maxHeight: '160px' }}
										/>
									</MuiThemeProvider>
								</div>
							</div>
						</div>
							: ''}
						{/*this.state.hr_permission == 'yes' ? <div class="form-group row">
							<label for="staticEmail" class="col-sm-3 col-form-label">Functional Lead</label>
							<div class="col-sm-9 col-xs-12">
								<div class="filter" name="func_manager">
								<MuiThemeProvider muiTheme={getMuiTheme()} class="form-control">
								<AutoComplete
									   onUpdateInput={this.handleUpdateInput_func_manager}
									onNewRequest={ this.onNewRequest_func_manager.bind(this) }
									onClick={this.handleUpdateInput_func_manager}
									fullWidth={true}
									placeholder="Type here to functional lead Name"
									filter={AutoComplete.caseInsensitiveFilter}
									dataSource={this.state.search}
									dataSourceConfig={dataSourceConfig}
									errorStyle={{ bottom: 0 }}
									errorText={this.state.errorText2}
									maxSearchResults={500}
									className="ticket_search_box"
									searchText={this.state.searchText2}
									openOnFocus = {true}
									menuStyle = {{maxHeight: '160px'}}
								 />
							</MuiThemeProvider>
							</div>
						</div>
						</div>
						 : ''*/}
						{this.state.hr_permission == 'yes' ? <div class="form-group row">
							<label for="staticEmail" class="col-sm-3 col-form-label">Work Location</label>
							<div class="col-sm-9 col-xs-12">
								<select class="form-control emp_new_fields" placeholder="Select Level" name="emp_location_save" onChange={this.onChange.bind(this, 'worklocation')} value={this.state.employee.worklocation}>
									<option value="">Select Work Location</option>
									<option value="Remote">Remote</option>
									<option value="Onsite">Onsite</option>
								</select>
								{/*<input type="text" id="emp_location_save" name="emp_location_save" class="form-control emp_new_fields" onChange={this.onChange.bind(this, 'worklocation')} value={this.state.employee.worklocation} />*/}
							</div>
						</div> : ''}
						{this.state.hr_permission == 'yes' || this.state.manager_permission == 'yes' ? <div class="form-group row">
							<label for="staticEmail" class="col-sm-3 col-form-label">Level<span class="star">*</span></label>
							<div class="col-sm-9 col-xs-12">
								<select class="form-control emp_new_fields" placeholder="Select Level" name="emp_level_save" onChange={this.onChange.bind(this, 'level')} value={this.state.employee.level}>
									<option value="">Select Level</option>
									<option value="R1">R1</option>
									<option value="R2">R2</option>
									<option value="R3">R3</option>
									<option value="R4">R4</option>
									<option value="R5">R5</option>
									<option value="R6">R6</option>
									<option value="R7">R7</option>
									<option value="R8">R8</option>
									<option value="R9">R9</option>
								</select>
								<span class="error">{this.state.errors["emp_level_save"]}</span>
							</div>
						</div> : ''}
						{this.state.hr_permission == 'yes' || this.state.manager_permission == 'yes' ?
							<div class="form-group row">
								<label for="staticEmail" class="col-sm-3 col-xs-5 col-form-label">Add snippet</label>
								<div class="col-sm-9 col-xs-7">
									<div class="radio-inline feature-check">
										<input class="valid_fld" id="0" value="0" type="radio" name="per_snippet_save" onChange={this.onChange.bind(this, 'snipeet_add_user')} checked={this.state.employee.snipeet_add_user === '0'} />
										<label for="0"><span></span>Optional</label>
									</div>
									<div class="radio-inline feature-check">
										<input class="valid_fld" id="1" value="1" type="radio" name="per_snippet_save" onChange={this.onChange.bind(this, 'snipeet_add_user')} checked={this.state.employee.snipeet_add_user === '1'} />
										<label for="1"><span></span>Mandatory</label>
									</div>
								</div>
							</div>
							: ''}
					</div>
				</div>
			</div>
		)
	}

	viewEmergencyInfo() {
		return (
			<div>
				<span class="job_title">Emergency Contact Information</span>
				<span class="emps_edit" id="emr_edit" style={{}}><a href="javascript:void(0);" class="btn btn-trans Medium" onClick={this.emr_edit.bind(this)}> <i class="fa fa-pencil-square-o" aria-hidden="true"></i> Edit</a></span>
				<div class="row intra_form">

					<div class="col-md-6 col-xs-12">
						<div class="form-group row">
							<label for="staticEmail" class="col-sm-3 col-xs-5 col-form-label">Name</label>
							<div class="col-sm-9 col-xs-7">
								<span class="emr_old_fields">{this.state.employee.emr_name}</span>
							</div>
						</div>
						<div class="form-group row">
							<label for="inputPassword" class="col-sm-3 col-xs-5 col-form-label">Address</label>
							<div class="col-sm-9 col-xs-7">
								<span class="emr_old_fields">{this.state.employee.emr_address}</span>
							</div>
						</div>
						<div class="form-group row">
							<label for="staticEmail" class="col-sm-3 col-xs-5 col-form-label">State</label>
							<div class="col-sm-9 col-xs-7">
								<span class="emr_old_fields">{this.state.employee.emr_state}</span>
							</div>
						</div>
						<div class="form-group row">
							<label for="staticEmail" class="col-sm-3 col-xs-5 col-form-label">Zip Code</label>
							<div class="col-sm-9 col-xs-7">
								<span class="emr_old_fields">{this.state.employee.emr_zipcode}</span>
							</div>
						</div>

					</div>
					<div class="col-md-6 col-xs-12">
						<div class="form-group row">
							<label for="staticEmail" class="col-sm-3 col-xs-5 col-form-label">Relationship</label>
							<div class="col-sm-9 col-xs-7">
								<span class="emr_old_fields">{this.state.employee.emr_relationship}</span>
							</div>
						</div>
						<div class="form-group row">
							<label for="inputPassword" class="col-sm-3 col-xs-5 col-form-label">City</label>
							<div class="col-sm-9 col-xs-7">
								<span class="emr_old_fields">{this.state.employee.emr_city}</span>
							</div>
						</div>
						<div class="form-group row">
							<label for="staticEmail" class="col-sm-3 col-xs-5 col-form-label">Country</label>
							<div class="col-sm-9 col-xs-7">
								<span class="emr_old_fields">{this.state.employee.emr_country}</span>
							</div>
						</div>
						<div class="form-group row">
							<label for="staticEmail" class="col-sm-3 col-xs-5 col-form-label">Phone Number</label>
							<div class="col-sm-9 col-xs-7">
								<span class="emr_old_fields">{this.state.employee.emr_phone_no}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}

	updateEmergencyInfo() {
		return (
			<div>
				<span class="job_title">Emergency Contact Information</span>
				<span class="emps_edit" id="emr_save" ><a a href="javascript:void(0);" class="btn btn-trans Medium" onClick={this.emr_save.bind(this)}><i class="fa fa-floppy-o" aria-hidden="true"></i> Save</a></span>
				<div class="row intra_form">

					<div class="col-md-6 col-xs-12">
						<div class="form-group row">
							<label for="staticEmail" class="col-sm-3 col-form-label">Name</label>
							<div class="col-sm-9 col-xs-12">
								<input type="text" id="emr_name_save" name="emr_name_save" class="form-control emr_new_fields" onChange={this.onChange.bind(this, 'emr_name')} value={this.state.employee.emr_name} />
								<span class="error">{this.state.errors["emr_name_save"]}</span>
							</div>
						</div>
						<div class="form-group row">
							<label for="inputPassword" class="col-sm-3 col-form-label">Address</label>
							<div class="col-sm-9 col-xs-12">
								<input type="text" id="emr_address_save" name="emr_address_save" class="form-control emr_new_fields" onChange={this.onChange.bind(this, 'emr_address')} value={this.state.employee.emr_address} />
								<span class="error">{this.state.errors["emr_address_save"]}</span>
							</div>
						</div>
						<div className="form-group row">
							<label className="col-sm-3 col-form-label">State</label>
							<div className="col-sm-9 col-xs-12">
								<select className="form-control" value={this.state.selectedEmrState} onChange={this.handleEmrStateChange} disabled={!this.state.selectedEmrCountry} name={'selectedEmrState'}>
									<option value="">Select State</option>
									{this.state.emrstates.map(state => (
										<option key={state.iso2} value={state.iso2} >
											{state.name}
										</option>
									))}
								</select>
							</div>
						</div>
						<div class="form-group row">
							<label for="staticEmail" class="col-sm-3 col-form-label">Zip Code</label>
							<div class="col-sm-9 col-xs-12">
								<input type="text" id="emr_zip_save" name="emr_zip_save" class="form-control emr_new_fields" onChange={this.onChange.bind(this, 'emr_zipcode')} value={this.state.employee.emr_zipcode} />
								<span class="error">{this.state.errors["emr_zip_save"]}</span>
							</div>
						</div>
					</div>
					<div class="col-md-6 col-xs-12">
						<div class="form-group row">
							<label for="staticEmail" class="col-sm-3 col-form-label">Relationship</label>
							<div class="col-sm-9 col-xs-12">
								<input type="text" id="emr_rel_save" name="emr_rel_save" class="form-control emr_new_fields" onChange={this.onChange.bind(this, 'emr_relationship')} value={this.state.employee.emr_relationship} />
								<span class="error">{this.state.errors["emr_rel_save"]}</span>
							</div>
						</div>
						<div className="form-group row">
							<label className="col-sm-3 col-form-label">Country</label>
							<div className="col-sm-9 col-xs-12">
								<select className="form-control" value={this.state.selectedEmrCountry} onChange={this.handleEmrCountryChange} name={'selectedEmrCountry'}>
									<option value="">Select Country</option>
									{this.state.emrcountries.map(country => (
										<option key={country.iso2} value={country.iso2} >
											{country.name}
										</option>
									))}
								</select>
							</div>
						</div>
						<div className="form-group row">
							<label className="col-sm-3 col-form-label">City</label>
							<div className="col-sm-9 col-xs-12">
								<select className="form-control" value={this.state.selectedEmrCity} onChange={this.handleEmrCityChange} disabled={!this.state.selectedEmrState} name={'selectedEmrCity'}>
									<option value="">Select City</option>
									{this.state.emrcities.map(city => (
										<option key={city.id} value={city.name} >
											{city.name}
										</option>
									))}
								</select>
							</div>
						</div>
						<div class="form-group row">
							<label for="staticEmail" class="col-sm-3 col-form-label">Phone Number</label>
							<div class="col-sm-9 col-xs-12">
								<input type="text" id="emr_phone_save" name="emr_phone_save" class="form-control emr_new_fields" onChange={this.onChange.bind(this, 'emr_phone_no')} value={this.state.employee.emr_phone_no} />
								<span class="error">{this.state.errors["emr_phone_save"]}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}

	editConfidentialInfo() {
		return (
			<div>
				<span class="job_title">Confidential Information</span>
				{(this.state.hr_permission == 'yes' || this.state.edit_access == 1) ? <span class="emps_edit" id="con_edit" style={{}}><a href="javascript:void(0);" class="btn btn-trans Medium" onClick={this.con_edit.bind(this)}> <i class="fa fa-pencil-square-o" aria-hidden="true"></i> Edit</a></span> : ''}
				<div class="row intra_form">
					<div class="col-md-6 col-xs-12">
						<div class="form-group row">
							<label for="staticEmail" class="col-sm-3 col-xs-5 col-form-label">PAN Number</label>
							<div class="col-sm-7 col-xs-7">
								<span class="con_old_fields">{this.state.employee.pan}</span>
							</div>
							<div class="col-sm-2 col-xs-12">
								{this.state.employee.attachment_pan ? <span onClick={() => this.downloadImage(this.state.employee.id, 1)}><div class="perso_id"><i class="fal fa-cloud-download"></i></div></span> : ''}
							</div>

						</div>

						<div class="form-group row">
							<label for="inputPassword" class="col-sm-3 col-xs-5 col-form-label">Passport Number</label>
							<div class="col-sm-7 col-xs-7">
								<span class="con_old_fields">{this.state.employee.passport}</span>
							</div>
							<div class="col-sm-2 col-xs-12">
								{this.state.employee.attachment_passport ? <span onClick={() => this.downloadImage(this.state.employee.id, 2)}><div class="perso_id"><i class="fal fa-cloud-download"></i></div></span> : ''}
							</div>
						</div>

						<div class="form-group row">
							<label for="staticEmail" class="col-sm-3 col-xs-5 col-form-label">Aadhar Number</label>
							<div class="col-sm-7 col-xs-7">
								<span class="con_old_fields">{this.state.employee.adhaar}</span>
							</div>
							<div class="col-sm-2 col-xs-12">
								{this.state.employee.attachment_adhar ? <span onClick={() => this.downloadImage(this.state.employee.id, 3)}><div class="perso_id"><i class="fal fa-cloud-download"></i></div></span> : ''}
							</div>
						</div>
					</div>
					<div class="col-md-6 col-xs-12">
						<div class="form-group row">
							<label for="staticEmail" class="col-sm-3 col-xs-5 col-form-label">Blood Group</label>
							<div class="col-sm-9 col-xs-7">
								<span class="con_old_fields">{this.state.employee.blood_group}</span>
							</div>
						</div>

						<div class="form-group row">
							<label for="staticEmail" class="col-sm-3 col-xs-5 col-form-label">Hierarchy Level</label>
							<div class="col-sm-9 col-xs-7">
								<span class="con_old_fields">{this.state.employee.hierarchy_level}</span>
							</div>
						</div>
						<div class="form-group row">
							<label for="staticEmail" class="col-sm-3 col-xs-5 col-form-label">ESOP</label>
							<div class="col-sm-9 col-xs-7">
								<span class="con_old_fields">{this.state.employee.esop}{this.state.employee.esop_val ? <strong> (<i class="fa fa-inr"></i> {this.state.employee.esop_val})</strong> : ""}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}

	saveConfidentialInfo() {
		return (
			<div>
				<span class="job_title">Confidential Information</span>
				<span class="emps_edit" id="con_save">
					<a href="javascript:void(0);" class="btn btn-trans Medium" onClick={this.con_save.bind(this)}><i class="fa fa-floppy-o" aria-hidden="true"></i> Save</a></span>
				<div class="row intra_form">
					<div class="col-md-6 col-xs-12">
						<div class="form-group row perso_upload">
							<label for="staticEmail" class="col-sm-3 col-form-label">PAN Number</label>
							<div class="col-sm-7 col-xs-12">
								<input type="text" id="con_pan_save" name="con_pan_save" class="form-control con_new_fields" onChange={this.onChange.bind(this, 'pan')} value={this.state.employee.pan} />
								<span class="perso_text"></span>
							</div>
							<div class="col-sm-2 col-xs-12">
								<div class="perso_id">
									<input type="file" class="inputfile" id="pan_img" accept=".png, .jpg, .jpeg, .pdf" />
									<i class="fal fa-cloud-upload"></i>
								</div>
							</div>
						</div>
						{this.state.employee.attachment_pan ? <div class="upload show_upload">
							<h4 class="pull-left border-bottom"></h4>
							<div class="attached attach_delete">
								<span onClick={() => this.showImage(this.state.employee.attachment_url + this.state.employee.attachment_pan)}  >
									<i class="far fa-file"></i>{this.state.employee.attachment_pan}
								</span>
								<span class="delete" onClick={() => this.delteimage(this.state.employee.id, this.state.employee.attachment_pan, 1)}  >
									<i class="fa fa-trash"></i>
								</span>
							</div>
						</div> : ''}

						<div class="form-group row perso_upload">
							<label for="inputPassword" class="col-sm-3 col-form-label">Passport Number</label>
							<div class="col-sm-7 col-xs-12">
								<input type="text" id="con_passport_save" name="con_passport_save" class="form-control con_new_fields" onChange={this.onChange.bind(this, 'passport')} value={this.state.employee.passport} />
								<span class="perso_text"></span>
							</div>
							<div class="col-sm-2 col-xs-12">
								<div class="perso_id">
									<input type="file" id="passport_img" accept=".png, .jpg, .jpeg, .pdf" />
									<i class="fal fa-cloud-upload"></i>
								</div>
							</div>
						</div>
						{this.state.employee.attachment_passport ? <div class="upload show_upload">
							<h4 class="pull-left border-bottom "></h4>
							<div class="attached attach_delete">
								<span onClick={() => this.showImage(this.state.employee.attachment_url + this.state.employee.attachment_passport)}  >
									<i class="far fa-file"></i>{this.state.employee.attachment_passport}
								</span>
								<span class="delete" onClick={() => this.delteimage(this.state.employee.id, this.state.employee.attachment_passport, 2)}  >
									<i class="fa fa-trash"></i>
								</span>
							</div>
						</div> : ''}
						<div class="form-group row perso_upload">
							<label for="staticEmail" class="col-sm-3 col-form-label">Aadhar Number</label>
							<div class="col-sm-7 col-xs-12">
								<input type="text" id="con_adhaar_save" name="con_adhaar_save" class="form-control con_new_fields" onChange={this.onChange.bind(this, 'adhaar')} value={this.state.employee.adhaar} />
								<span class="perso_text"></span>
								<span class="error">{this.state.errors["con_adhaar_save"]}</span>
							</div>
							<div class="col-sm-2 col-xs-12">
								<div class="perso_id">
									<input type="file" id="adhar_img" accept=".png, .jpg, .jpeg, .pdf" />
									<i class="fal fa-cloud-upload"></i>
								</div>
							</div>
						</div>
						{this.state.employee.attachment_adhar ? <div class="upload show_upload">
							<h4 class="pull-left border-bottom"></h4>
							<div class="attached attach_delete">
								<span onClick={() => this.showImage(this.state.employee.attachment_url + this.state.employee.attachment_adhar)}  >
									<i class="far fa-file"></i>{this.state.employee.attachment_adhar}
								</span>
								<span class="delete" onClick={() => this.delteimage(this.state.employee.id, this.state.employee.attachment_adhar, 3)}  >
									<i class="fa fa-trash"></i>
								</span>
							</div>
						</div> : ''}
					</div>
					<div class="col-md-6 col-xs-12">
						<div class="form-group row">
							<label for="staticEmail" class="col-sm-3 col-form-label">Blood Group</label>
							<div class="col-sm-9 col-xs-12">
								<select class="form-control con_new_fields" id="con_blood_group_save" name="con_blood_group_save" value={this.state.employee.blood_group ? this.state.employee.blood_group : this.state.con_blood_group_save} onChange={this.onChange.bind(this, 'blood_group')}>
									<option value=""></option>
									<option value="A+">A+</option>
									<option value="A-">A-</option>
									<option value="B+">B+</option>
									<option value="B-">B-</option>
									<option value="O+">O+</option>
									<option value="O-">O-</option>
									<option value="AB+">AB+</option>
									<option value="AB-">AB-</option>
								</select>
							</div>
						</div>
						{this.state.hr_permission == 'yes' ? <div class="form-group row">
							<label for="staticEmail" class="col-sm-3 col-form-label">Hierarchy Level</label>
							<div class="form-group col-sm-9 col-xs-12">
								<select class="form-control con_new_fields" id="con_hierarchy_save" name="con_hierarchy_save" value={this.state.employee.hierarchy_level} onChange={this.onChange.bind(this, 'hierarchy_level')}>
									<option value=""></option>
									<option value="1">1</option>
									<option value="2">2</option>
									<option value="3">3</option>
									<option value="4">4</option>
								</select>
							</div>
						</div> : ''}

						{this.state.hr_permission == 'yes' ? <div class="form-group row">
							<label for="staticEmail" class="col-sm-3 col-form-label">ESOP</label>
							<div class="col-sm-9 col-xs-12">
								<input type="text" id="emr_esop_save" name="emr_esop_save" class="form-control con_new_fields" onChange={this.onChange.bind(this, 'esop')} value={this.state.employee.esop} />
								<span class="error">{this.state.errors["emr_esop_save"]}</span>
							</div>
						</div> : ''}
					</div>
				</div>
			</div>
		)
	}

	getConfidentialMenu() {
		return (
			<div>
				{/*<hr />
				<div class="title emps_mob">
					<div class="mob-angle hidden-md pull-left"><i class="fa fa-angle-left" onclick="goBack()"></i></div>
					{this.state.per_save_state == 1 ? this.viewPersonalInfo() : this.savePersonalInfo()}
				</div>*/}
				<hr />
				<div class="title emps_mob">
					<div class="mob-angle hidden-md pull-left"><i class="fa fa-angle-left" onclick="goBack()"></i></div>
					{this.state.con_save_state == 1 ? this.editConfidentialInfo() : this.saveConfidentialInfo()}
				</div>
				<hr />
				<div class="title emps_mob">
					<div class="mob-angle hidden-md pull-left"><i class="fa fa-angle-left" onclick="goBack()"></i></div>
					{this.state.emr_save_state == 1 ? this.viewEmergencyInfo() : this.updateEmergencyInfo()}
				</div>
			</div>
		)
	}

	getEmployeeId() {
		fetch(this.state.apiUrl + '/employee/getemployeeid/userAuthKey/' + this.state.userAuthKey + '/user_uuid/' + this.props.match.params.user_uuid, {
			method: 'POST',
			dataType: 'json'
		})
			.then((Response) => Response.json())
			.then((findresponse) => {
				findresponse = this.decrypt(findresponse, 1);
				if (findresponse.code == 200) {
					this.setState({
						'viewEmpId': findresponse.data
					});
					this.renderPage();
				}
			})
	}
	renderPage() {
		this.viewEmployee();
		//	this.userList();
		this.getDepartment();
	}
	componentDidUpdate = (prevProps, prevState) => {
		if (prevProps.match.params.employeeId !== this.props.match.params.employeeId) {
			this.setState({ viewEmpId: this.props.match.params.employeeId }, function () {
				this.renderPage();
			})
		}
	}

	componentDidMount() {
		if (!localStorage.getItem('userLogin')) {
			this.setState({ redirect: true });
		} else {
			if (this.props.match.params.user_uuid) {
				this.getEmployeeId();
			} else if (this.state.viewEmpId) {
				this.renderPage();
			}
		}

		$(document).on("click", ".perso_id i", function () {
			$(this).parent().find('input').click();
		});

		$(document).on("change", '.perso_id input[type="file"]', function (e) {
			var fileName = e.target.files[0].name;
			$(this).parent().closest('.perso_upload').find('.perso_text').html(fileName);
		});
		this.getEmployeeList();
	}

	//	ER:116571
	fetchCountries = async () => {
		try {
			const response = await fetch('https://api.countrystatecity.in/v1/countries', {
				headers: {
					'X-CSCAPI-KEY': 'bnpQUTF2TnNOYnZFQXJvRU9YRkhSMjFLUnBFZGI2ejhjaDhhcDNpQQ==',
				}
			});
			const countries = await response.json();
			// this.setState({ countries });
			return countries;
		} catch (error) {
			console.error("Error fetching countries:", error);
		}
	};

	fetchStates = async (countryCode) => {
		try {
			const response = await fetch(`https://api.countrystatecity.in/v1/countries/${countryCode}/states`, {
				headers: {
					'X-CSCAPI-KEY': 'bnpQUTF2TnNOYnZFQXJvRU9YRkhSMjFLUnBFZGI2ejhjaDhhcDNpQQ==',
				}
			});
			const states = await response.json();
			// this.setState({ states, cities: [], });
			return states;
		} catch (error) {
			console.error("Error fetching states:", error);
		}
	};

	fetchCities = async (countryCode, stateCode) => {
		try {
			const response = await fetch(`https://api.countrystatecity.in/v1/countries/${countryCode}/states/${stateCode}/cities`, {
				headers: {
					'X-CSCAPI-KEY': 'bnpQUTF2TnNOYnZFQXJvRU9YRkhSMjFLUnBFZGI2ejhjaDhhcDNpQQ==',
				}
			});
			const cities = await response.json();
			// this.setState({ cities, });
			return cities;
		} catch (error) {
			console.error("Error fetching cities:", error);
		}
	};

	handleCountryChange = async (e) => {
		let states = [];
		const selectedCountry = e.target.value;
		const Country = this.state.countries.find(country => country.iso2 === selectedCountry);
		console.log({ selectedCountry, per_country: Country.name })
		if (selectedCountry) {
			states = await this.fetchStates(selectedCountry);
		} else {
			this.setState({ states: [], cities: [], selectedState: '', selectedCity: '' });
		}
		this.setState({ selectedCountry, employee: { ...this.state.employee, per_country: Country.name }, states: states, selectedState: '', selectedCity: '' });
	};

	handleStateChange = async (e) => {
		let cities = [];
		const selectedState = e.target.value;
		const State = this.state.states.find(state => state.iso2 === selectedState);
		if (selectedState) {
			cities = await this.fetchCities(this.state.selectedCountry, selectedState);
		} else {
			this.setState({ cities: [], selectedCity: '' });
		}
		this.setState({ selectedState, employee: { ...this.state.employee, per_state: State.name }, cities: cities, selectedCity: '' });
	};

	handleCityChange = (e) => {
		this.setState({ selectedCity: e.target.value, employee: { ...this.state.employee, per_city: e.target.value } });
	};

	handleEmrCountryChange = async (e) => {
		let states = [];
		const selectedEmrCountry = e.target.value;
		const Country = this.state.emrcountries.find(country => country.iso2 === selectedEmrCountry);
		console.log({ selectedEmrCountry, per_country: Country.name })

		if (selectedEmrCountry) {
			states = await this.fetchStates(selectedEmrCountry);
		} else {
			this.setState({ emrstates: [], emrcities: [], selectedEmrState: '', selectedEmrCity: '' });
		}
		this.setState({ selectedEmrCountry, employee: { ...this.state.employee, emr_country: Country.name }, emrstates: states, selectedEmrState: '', selectedEmrCity: '' });
	};

	handleEmrStateChange = async (e) => {
		let cities = [];
		const selectedEmrState = e.target.value;
		const State = this.state.emrstates.find(state => state.iso2 === selectedEmrState);

		if (selectedEmrState) {
			cities = await this.fetchCities(this.state.selectedEmrCountry, selectedEmrState);
		} else {
			this.setState({ emrcities: [], selectedEmrCity: '' });
		}
		this.setState({ selectedEmrState, employee: { ...this.state.employee, emr_state: State.name }, emrcities: cities, selectedEmrCity: '' });
	};

	handleEmrCityChange = (e) => {
		this.setState({ selectedEmrCity: e.target.value, employee: { ...this.state.employee, emr_city: e.target.value } });
	};

	AddValuesModal = ({ id, heading, options, disabledOptions, onSubmit }) => {
		const filterOptions = createFilterOptions({
			matchFrom: 'start',
			stringify: option => option.name,
		});

		const [selected, setSelected] = useState([]);
		const [loading, setLoading] = useState(false);
		const [error, setError] = useState('');
		const dismissRef = useRef(null);

		const handleOpen = () => {
			setSelected([]);
			setError('');
			setLoading(false);
		}

		const handleChange = (selectedList) => {
			setSelected(selectedList);
		}

		const handleSubmit = async () => {
			setLoading(true);

			if (selected.length <= 0) {
				setError('Please select at least one option');
				setLoading(false);
				return;
			}
			
			const resp = await onSubmit(selected);

			if (resp && resp.code === 200) {
				setSelected([]);
				setError('');
				if (dismissRef && dismissRef.current) {
					dismissRef.current.click();
				}
			} else {
				setError(resp && resp.message || 'Something went wrong');
			}
			setLoading(false);
		}

		return (
			<React.Fragment>
				{
					this.state.hr_permission == 'yes' && (
						<div class="addBtn" data-toggle="modal" data-target={`#${id}`} onClick={() => handleOpen()}>
							<i class="far fa-plus"></i>
						</div>
					)
				}
				<div class="modal fade in" id={id} tabindex="-1" role="dialog" aria-labelledby={id} aria-hidden="true">
					<div class="modal-dialog modal-dialog-centered modal-dialog modal-md" role="document">
						<div class="modal-content">
							<div class="modal-header">
								<h4 class="modal-title">{heading}</h4>
								<button type="button" class="close" data-dismiss="modal">×</button>
							</div>
							<div class="modal-body row">
								<div class="mt-3 float-left popup_tag_area">
									<form>
										<div class="form-group row">
											<div class="col-sm-12">
												<div>
													{(options || []).length > 0 ?
														<CustomAutocomplete
															multiple
															options={options || []}
															groupBy={(id != "AddPermissions" && id != "AddPermissionsEdit" ) ? (option) => option.group_type_name || 'Other' : null}
															getOptionLabel={(option) => option.name}
															onChange={(event , value) => handleChange(value)}
															getOptionDisabled={(option) => !! disabledOptions.find(element => element.id === option.id)}
															value={selected}
															filterOptions={filterOptions}
															filterSelectedOptions
															renderGroup={(params) => (
																<div key={params.key}>
																	<div style={{ 
																		fontWeight: 'bold', 
																		padding: '8px 16px', 
																		backgroundColor: '#f5f5f5',
																		borderBottom: '1px solid #ddd',
																		textTransform: 'capitalize'
																	}}>
																		{params.group}
																	</div>
																	{params.children}
																</div>
															)}
															renderInput={(params) => (
																<TextField
																	{...params}
																	variant="outlined"
																	// label="Users Names"
																	placeholder="Select"
																/>
																)}
														/> :''}
												</div>
											</div>
										</div>
										<span class="error ml-10">{error}</span>
									</form>
								</div>
							</div>
							<div class="modal-footer">
								<button type="button" class="btn btn-secondary" data-dismiss="modal">Dismiss</button>
								{loading ? (
									<button type="submit" class="btn btn-sky disabled" >
										<div>
											<i class="fa fa-spinner fa-spin"></i>
											<span>Adding</span>
										</div>
									</button>
								) : (
									<button type="button" class="btn btn-sky" onClick={() => handleSubmit()}>Add</button>
								)}
								<button ref={dismissRef} type="button" data-dismiss="modal" class="hide" id="dismiss2"></button>
							</div>
						</div>
					</div>
				</div>
			</React.Fragment>
		)
	}

	DeleteConfirmationModal = ({ id, message, onConfirm }) => {
		const dismissRef = useRef(null);
		const [loading, setLoading] = useState(false);

		const handleConfirm = async () => {
			setLoading(true);
			await onConfirm();
			if (dismissRef && dismissRef.current) {
				dismissRef.current.click();
			}
			setLoading(false);
		}

		return (
			<div className="modal fade" id={id} tabIndex="-1" data-backdrop="static" data-keyboard="false" role="dialog" aria-hidden="true">
				<div className="modal-dialog" role="document">
					<div className="modal-content">
						<div className="modal-body">
							<div className="icon_txt">
							{message}
							</div>
							<p className="mt20 pull-right">
								<button disabled={loading} className="btn btn-blue" data-dismiss="modal">Cancel</button>
								<button disabled={loading} type="button" class="btn btn-sky" onClick={() => handleConfirm()}>
									{loading ? (
										<div style={{ display: 'flex', alignItems: 'center' }}>
											<i class="fa fa-spinner fa-spin"></i>
											<span>Removing</span>
										</div>
									) : 'Remove'}
								</button>
							</p>
							<button ref={dismissRef} type="button" data-dismiss="modal" class="hide" id="dismiss2"></button>
							<div class="clear"></div>
						</div>
					</div>
				</div>
			</div>
		)
	}

	//ER:116571

	render() {
		if (this.state.redirect) {
			return (
				<Redirect to={'/login'} />
			)
		}
		return (
			<div>
				<Header brecum_name="Employee" brecum_page="Employee Details" profileImg={this.state.userId == this.state.viewEmpId ? this.state.employee.profile_image : ""} />
				<div class="right_col" role="main">
					<section class="intranet_body">
						<div class="title mob hidden-md"><HeaderMob page_name="Employee Details" /></div>
						<div class="title emps_mob">
							<div class="mob-angle hidden-md pull-left"><i class="fa fa-angle-left" onclick="goBack()"></i></div>
							{this.state.job_save_state == 1 ? this.viewJobInfo() : this.saveJobInfo()}
						</div>
						{!this.state.loading ?
							<div class="title emps_mob">
								<div class="mob-angle hidden-md pull-left"><i class="fa fa-angle-left" onclick="goBack()"></i></div>
								{this.state.per_save_state == 1 ? this.viewPersonalInfo() : this.savePersonalInfo()}
							</div>
							: ""}
						{this.state.view_access == 0 ? '' : this.getConfidentialMenu()}

						{this.state.employee && this.state.employee.email && (
							<EmployeeActivityInsightsTable email={this.state.employee.email} />
						)}

						<div class="intra_form">
							{/*<Link to={`/manageEmployee/`} name={"max"}> <button className="btn btn-blue mob-btn" >Back</button></Link>*/}
							<button className="btn btn-blue mob-btn" onClick={() => this.goBack()}>Back</button>

							{this.state.hr_permission == 'yes' ?
								<button class="btn btn-sky" data-toggle="modal" data-target="#ViewReport" data-dismiss="modal">View Report</button> : ''}

						</div>
					</section>
				</div>
				{/* <--modal start for View Report-!> */}
				<div class="modal fade" id="ViewReport" role="dialog">
					<div class="modal-dialog modal-md">
						<div class="modal-content">
							<div class="modal-header">
								<button type="button" class="close" data-dismiss="modal">&times;</button>
								<h4 class="modal-title">Peer Score</h4>
							</div>
							<div class="modal-body">
								<div class="row">
									<div class="peer-pop">
										<div class="add_dash">
											<div class="dash_price">{this.state.myscore[0] ? this.state.myscore[0] : '--'}</div>
											<div class="dash_wb">Overall Score</div>
										</div>
									</div>
								</div>
								<div class="list_check peer-row">
									<div class="tickets">
										<ul class="tickets_head">
											<li class="col-md-9 col-xs-8"><span class="peer-comment">Indicators</span></li>
											<li class="col-md-3 col-xs-4"><span class="peer-comment">Average Score</span></li>
										</ul>
										<div class="peer-block">
											{this.state.peer_question.map
												((data, key) =>
													<ul className="tickets_number">
														<li class="col-md-9 col-xs-8">
															<h5>{data.question}</h5>
															<p>{data.ques_description}</p>
														</li>
														<li class="col-md-3 col-xs-4 peer_res">
															{this.state.myscore[key] ? this.state.myscore[key] : "--"}
														</li>
													</ul>
												)}</div>
									</div>
								</div>
								{Object.keys(this.state.comments).length > 0 ?
									<span >Overall Notes:
										<div class="peer-comment note">
											{this.state.comments.map
												((data, key) =>
													<div class="peer_comt" dangerouslySetInnerHTML={{ __html: data }} />
												)}
										</div>
									</span> : ""}
							</div>
							<div class="modal-footer">
								<button type="button" class="btn btn-blue" data-dismiss="modal">Close</button>
							</div>

						</div>

					</div>
				</div>
				{/* <--modal end for View Report-!> */}

			</div>
		)
	}
}

export default ViewEmployee;


// WEBPACK FOOTER //
// ./src/components/hrAdmin/viewEmployee.js